/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-07-10 08:48:00
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-01-12 17:10:01
 */
import React, { useEffect, useMemo, useState } from 'react'
import { useRelateField } from '@/modules/goodsdetailmodules/goodsSubmissionInfo.tsx/useRelateField'
import Table from '@/components/CustomTable'
import {
  BulbOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import {
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  message,
  Spin,
  FormInstance,
  Tooltip,
  Space,
  InputNumber,
} from 'antd'
import CustomModal from '@/components/ModalUser'
import UpdateImg from './components/UpdateImg'
import PreviewUser from '@/components/PreviewUser'
import Style from './style.module.scss'
import CustomMultiSelect from './components/CustomMutilSelect'
import { debounce } from 'lodash'
import { useRef } from 'react'
import {
  qualityTypeList,
  qualityTypeEnum,
  reportTypeEnumValue,
  reportTypeEnum,
  shelfStatusList,
  attributeTypeEnum,
} from '@/global/enum/product'
import {
  GET_BRAND_INFO,
  BrandInfoVO,
  CategoryInfoVO,
  GET_CATEGORY_POOL,
  ProductWordInfoVO,
  SpecAttributeForScpVo,
  ExtendedInfo,
  GET_LIST_WORD,
  GET_SPEC_ATTRIBUTE_VALUE_LIST,
  POST_SAVE_SPEC_ATTRIBUTE_VALUE_AND_RETURN_CODE,
  QualityList,
  POST_IS_REQUIRED_SPEC_ATTRIBUTE_FOR_SUBMIT,
  GET_WUHAN_SALE_PERSON_LIST,
  GET_THIRD_PRODUCT_CODE_LIST,
  POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
  POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
  POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
  SpecAttributeValueForScpVO,
  ProjectCategoryRecommendationMaterial,
} from '@/api/reportApi'
import { BrandSelect } from '@/components/BrandSelect'
import {
  RECOMMEND_FAILED_TEXT,
  RECOMMEND_LOADING_TEXT,
  useProjectCategoryRecommend,
} from './components/ProjectCategoryRecommend/useProjectCategoryRecommend'
import RecommendStyle from './components/ProjectCategoryRecommend/style.module.scss'
import { isResponseCodeSuccess } from '@/tools/util'
import {
  forgetProjectCategoryAdoption,
  rememberProjectCategoryAdoption,
} from '@/tools/projectCategoryAdopt'
import { checkNumberRange, parseNumberRange } from '@/tools/numberRange'
import { findUnboundRequiredAttributes } from '@/tools/specAttribute'
import { PreCheckErrors } from '@/api/MaterialApi'

interface Props {
  extendedInfoList: ExtendedInfo[]
  projectCode: string
  form: FormInstance
  normalForm: FormInstance
  submissionType?: reportTypeEnumValue
  qualityDataList: QualityList[]
  setQualityDataListAction: (data: QualityList[]) => void
  readOnly?: boolean
  isDetailPage?: boolean // 是否是详情页面
  isShowSaleInfo?: boolean // 是否显示销售审核
  preCheckErrors?: PreCheckErrors
  showRate?: '1' | '0'
  relateFieldKeySet?: Set<string> // 需要监听 blur 的关联字段 Key 集合
  onRelateFieldBlur?: (fieldKey: string, value: any) => void // blur 回调
  validationInfo?: React.ReactNode
}

// 字段含义枚举
const FIELD_MEANING = {
  BRAND: '1', // 品牌
  CATEGORY: '2', // 类目
  PRODUCT_WORD: 'wordCode', // 产品词
  ATTRIBUTE_CODE: 'specAttributeValueCode', // 属性值编码
  THIRD_PRODUCT_CODE: 'thirdProductCode', //
} as const

// 控件类型枚举
const CONTROL_TYPE = {
  SELECT: '3',
  NUMBER: '6',
  // 整数:'7'
  INTEGER: '7',
  // 正整数:'8'
  POSITIVE_INTERGE: '8',
  // 数字字符串（为解决大额数字科学计数法问题）:9
  NUMBER_STRING: '9',
} as const

// 受 numberRange 数值范围校验的控件
const NUMBER_RANGE_CONTROL_TYPES: string[] = [
  CONTROL_TYPE.NUMBER,
  CONTROL_TYPE.INTEGER,
  CONTROL_TYPE.POSITIVE_INTERGE,
]

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}

// 提报商品详情
const GoodsSubmissionInfo: React.FC<Props> = (props) => {
  const {
    extendedInfoList,
    projectCode,
    form,
    normalForm,
    submissionType = 'NEW',
    qualityDataList = [],
    setQualityDataListAction,
    readOnly = false,
    isDetailPage = false,
    isShowSaleInfo = true,
    preCheckErrors,
    showRate,
    relateFieldKeySet,
    onRelateFieldBlur,
    validationInfo,
  } = props

  const [batchVisible, setBatchVisibleAction] = useState(false)
  // 上传的图片数据
  const [uploadFileData, setUploadFileDataAction] = useState<QualityList[]>([])
  const [uploadLoading, setUploadLoading] = useState(false)
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  const [loading, setLoading] = useState(false)
  // const [brandList, setBrandList] = useState<BrandInfoVO[]>([])
  const [categoryList, setCategoryList] = useState<CategoryInfoVO[]>([])
  const [productWordList, setProductWordList] = useState<ProductWordInfoVO[]>(
    [],
  )
  const [attributeBindVisible, setAttributeBindVisible] = useState(false)
  const [attributeBindLoading, setAttributeBindLoading] = useState(false)
  const [attributeBindData, setAttributeBindData] = useState<
    SpecAttributeForScpVo[]
  >([])
  // 属性列表按类目和产品词缓存，属性绑定弹框与提交校验共用，同一组参数只查一次
  const specAttributeListCache = useRef(
    new Map<string, Promise<SpecAttributeForScpVo[] | undefined>>(),
  )
  const getSpecAttributeCacheKey = (categoryCode: string, wordCode?: string) =>
    `${projectCode}|${categoryCode}|${wordCode || ''}`
  const [attributeRequired, setAttributeRequired] = useState<boolean>(true)
  const [specialField, setSpecialField] = useState<{
    category: string
    productWord: string
    attribute: string
  }>({
    category: '',
    productWord: '',
    attribute: '',
  })
  const [wuhanSalePersonList, setWuhanSalePersonList] = useState<any[]>([])
  const [attributeBindForm] = Form.useForm()
  const [qualityList] = Form.useForm()
  const [thirdProductCodeList, setThirdProductCodeList] = useState<any[]>([])
  const [thirdProductSearchName, setThirdProductSearchName] =
    useState<string>('')

  // const getBrandInfo = async () => {
  //   const res = await GET_BRAND_INFO({ platformCode: projectCode })
  //   setBrandList(res.data)
  // }
  // const getCategoryPool = async () => {
  //   const res = await GET_CATEGORY_POOL({ platformCode: projectCode })
  //   setCategoryList(res.data)
  // }
  // 替换原来的 getCategoryPool
  const getCategoryPool = async (searchName?: string) => {
    if (!projectCode) return
    const res = await GET_CATEGORY_POOL({
      platformCode: projectCode,
      name: searchName?.trim() || undefined, // 空字符串不传，避免后端查空字符串
    })
    setCategoryList(res.data || [])
  }

  const getWuhanSalePersonList = async () => {
    const res = await GET_WUHAN_SALE_PERSON_LIST()
    setWuhanSalePersonList(res.data)
  }
  const getThirdProductCodeList = async (searchName?: string) => {
    const res = await GET_THIRD_PRODUCT_CODE_LIST({
      platformCode: projectCode,
      name: searchName?.trim() || undefined,
    }) // 为空时不传
    setThirdProductCodeList(res.data || [])
  }
  useEffect(() => {
    setLoading(true)
    if (!projectCode) return
    // 获取品牌数据
    // getBrandInfo()
    // 获取类目数据
    getCategoryPool()
    setLoading(false)
    if (projectCode === '46') {
      getWuhanSalePersonList()
    }
    // 管网主数据编码、南水北调标品编码：进页面先加载一批标准库物料供下拉选择
    if (['46', 'WZ1863'].includes(projectCode)) {
      getThirdProductCodeList()
    }
  }, [projectCode])

  // 枚举字段回显归一：历史数据可能把中文 label 当 value 存，这里映射回 value，映射不到返回 undefined 强制重选
  const matchEnumOption = (field: ExtendedInfo, raw?: string) => {
    const options = field.fieldEnumValueList
    if (!options?.length || raw === undefined || raw === null || raw === '') {
      return undefined
    }
    return (
      options.find((option) => option.value === raw) ??
      options.find((option) => option.label === raw)
    )
  }

  useEffect(() => {
    if (!projectCode) return
    // 先处理品牌和类目的回显
    extendedInfoList?.forEach((item) => {
      const normalize = (v: any) =>
        v === '' || v === 'null' || v === null || v === undefined
          ? undefined
          : v

      if (
        item.fieldMeaning === FIELD_MEANING.BRAND ||
        item.fieldMeaning === FIELD_MEANING.CATEGORY ||
        item.controlType === CONTROL_TYPE.SELECT ||
        item.fieldMeaning === FIELD_MEANING.THIRD_PRODUCT_CODE
      ) {
        if (item.fieldMeaning === FIELD_MEANING.BRAND) {
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}_name`]: normalize(
              item.fieldValueName ||
                form.getFieldValue(`${projectCode}_${item.fieldKey}_name`),
            ),
            [`${projectCode}_${item.fieldKey}`]: normalize(
              form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
                item.fieldValue,
            ),
          })
        } else if (
          item.fieldMeaning !== FIELD_MEANING.CATEGORY &&
          item.fieldMeaning !== FIELD_MEANING.PRODUCT_WORD &&
          item.fieldMeaning !== FIELD_MEANING.THIRD_PRODUCT_CODE &&
          item.controlType === CONTROL_TYPE.SELECT &&
          item.fieldEnumValueList?.length
        ) {
          const raw =
            form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
            item.fieldValue
          const matched = matchEnumOption(item, raw)
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}`]: matched?.value,
            [`${projectCode}_${item.fieldKey}_name`]: matched?.label,
          })
        } else {
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}_name`]: normalize(
              form.getFieldValue(`${projectCode}_${item.fieldKey}_name`) ||
                item.fieldValueName,
            ),
            [`${projectCode}_${item.fieldKey}`]: normalize(
              form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
                item.fieldValue,
            ),
          })
        }
      } else {
        form.setFieldsValue({
          [`${projectCode}_${item.fieldKey}`]: normalize(
            form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
              item.fieldValue,
          ),
        })
      }
    })

    // 然后处理特殊字段的设置
    const newSpecialField = {
      category: '',
      productWord: '',
      attribute: '',
      thirdProductCode: '',
    }

    extendedInfoList?.forEach((item) => {
      if (item.fieldMeaning === FIELD_MEANING.CATEGORY) {
        // 类目字段
        newSpecialField.category = `${projectCode}_${item.fieldKey}`
      }
      if (item.fieldMeaning === FIELD_MEANING.PRODUCT_WORD) {
        // 产品词字段
        newSpecialField.productWord = `${projectCode}_${item.fieldKey}`
      }
      if (item.fieldMeaning === FIELD_MEANING.ATTRIBUTE_CODE) {
        // 产品词字段
        newSpecialField.attribute = `${projectCode}_${item.fieldKey}`
      }
      if (item.fieldMeaning === FIELD_MEANING.THIRD_PRODUCT_CODE) {
        // 管网主数据编码字段
        newSpecialField.thirdProductCode = `${projectCode}_${item.fieldKey}`
      }
    })

    setSpecialField(newSpecialField)
  }, [projectCode, extendedInfoList])
  const categoryWatch = Form.useWatch(specialField.category, form)
  // 航发品牌栏显示「中文（英文）/品牌编码」，提交的仍只是品牌名称
  const aeccBrandField =
    projectCode === '132'
      ? extendedInfoList?.find(
          (item) => item.fieldMeaning === FIELD_MEANING.BRAND,
        )
      : undefined
  const aeccBrandCodeWatch = Form.useWatch(
    aeccBrandField ? `${projectCode}_${aeccBrandField.fieldKey}` : '',
    form,
  )

  useEffect(() => {
    // specialField 还未就绪时，不执行依赖类目的联动逻辑，避免首屏误禁用/误清空
    if (!specialField.category) return
    const category = form.getFieldValue(specialField.category)
    if (category) {
      // 通过类目获取产品词
      getProductWord(category)
      const haveAttribute = extendedInfoList.some(
        (item) => item.fieldMeaning === FIELD_MEANING.ATTRIBUTE_CODE,
      )
      if (haveAttribute) {
        getAttributeRequired(
          category,
          form.getFieldValue(specialField.productWord),
        )
      }
    } else {
      // 类目数据清空,产品词清空,属性必填
      setAttributeRequired(true)
      setProductWordList([])

      // 清空所有品牌字段
      extendedInfoList?.forEach((item) => {
        if (item.fieldMeaning === FIELD_MEANING.BRAND) {
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}`]: undefined,
            [`${projectCode}_${item.fieldKey}_name`]: undefined,
          })
        }
      })
    }
  }, [specialField, categoryWatch])

  // 使用抽取出来的关联字段 Hook
  const fieldConfigs = extendedInfoList.map((field) => ({
    fieldKey: field.fieldKey!,
    projectCode,
    relateField: field.relateField,
    relateFieldEnumValue: field.relateFieldEnumValue,
  }))

  const { disabledStates } = useRelateField(fieldConfigs, form, projectCode)

  const handlePreviewImage = (index: number) => {
    const url: string[] = []
    qualityDataList.forEach((item) => {
      if (item.url.indexOf('.pdf') === -1) {
        url.push(`${item.baseUrl}${item.url}`)
      }
    })
    setPreviewimg({
      data: url,
      currentIndex: index,
    })
  }

  // 资质图片列表
  const qualityColumns = [
    {
      title: '图片资质类型',
      key: 'sourceType',
      dataIndex: 'sourceType',
      width: 120,
      render: (text: string) => qualityTypeEnum.getLabelByValue(text),
    },
    {
      title: '图片',
      key: 'url',
      dataIndex: 'url',
      render: (text: string, record: QualityList) => {
        return text ? (
          <a onClick={() => window.open(`${record.baseUrl}${text}`)}>
            {record.baseUrl}
            {text}
          </a>
        ) : (
          '-'
        )
      },
    },
    {
      title: '操作',
      key: 'action',
      dataIndex: 'action',
      width: 200,
      render: (text: string, record: QualityList, index: number) => {
        return (
          <>
            {record.url.endsWith('.pdf') ? (
              <a
                onClick={() => window.open(`${record.baseUrl}${record.url}`)}
                style={{ marginRight: '7px' }}
              >
                点击预览
              </a>
            ) : (
              <Button type="link" onClick={() => handlePreviewImage(index)}>
                点击预览
              </Button>
            )}
            <Button
              type="link"
              onClick={() => handleDeleteImage(record.url)}
              disabled={readOnly}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]

  // 属性绑定列表
  const attributeBindColumns = [
    {
      title: '属性编码',
      key: 'specAttributeCode',
      dataIndex: 'specAttributeCode',
      width: 120,
    },
    {
      title: '属性名称',
      key: 'specAttributeName',
      dataIndex: 'specAttributeName',
      width: 150,
    },
    {
      title: '属性类型',
      key: 'attributeType',
      dataIndex: 'attributeType',
      width: 120,
      render: (text: string) => {
        return attributeTypeEnum.getLabelByValue(text)
      },
    },
    {
      title: '是否销售属性',
      key: 'isSaleAttribute',
      dataIndex: 'isSaleAttribute',
      width: 120,
      render: (text: string) => {
        return text === '1' ? '是' : '否'
      },
    },
    {
      title: '是否必填',
      key: 'required',
      dataIndex: 'required',
      width: 120,
      render: (text: string) => {
        return text === '1' ? '是' : '否'
      },
    },
    {
      title: '属性值名称',
      key: 'attributeValue',
      dataIndex: 'attributeValue',
      width: 300,
      render: (text: string, record: any) => {
        return (
          <div className={Style.attributeValueCell}>
            <Form.Item
              name={`${record.specAttributeCode}_value`}
              style={{ width: '100%', marginBottom: 0 }}
              rules={[
                { required: record.required === '1', message: '请添加属性值' },
              ]}
            >
              {renderAttribute(record, attributeBindForm)}
            </Form.Item>
          </div>
        )
      },
    },
  ]

  // 渲染属性选择器
  const renderAttribute = (record: any, attributeBindForm: FormInstance) => {
    const { specAttributeValueForScpVOList = [] } = record
    if (attributeTypeEnum.isLabelsMatchValue(['单选'], record.attributeType)) {
      const defaultValues =
        specAttributeValueForScpVOList.find(
          (item: SpecAttributeValueForScpVO) => item.selected,
        )?.specAttributeValueCode || ''

      attributeBindForm.setFieldsValue({
        [`${record.specAttributeCode}_value`]: defaultValues,
      })
      return (
        <Select
          placeholder="请选择属性值"
          allowClear
          style={{ width: '100%' }}
          // defaultValue={attributeBindForm.getFieldValue(
          //   `${record.specAttributeCode}_value`,
          // )}
          onChange={(value, option: any) => {
            // 保存选中的值和标签
            attributeBindForm.setFieldsValue({
              [`${record.specAttributeCode}_value`]: value,
            })
          }}
          options={record.specAttributeValueForScpVOList}
          fieldNames={{
            value: 'specAttributeValueCode',
            label: 'specAttributeValueName',
          }}
        />
      )
    }
    if (attributeTypeEnum.isLabelsMatchValue(['多选'], record.attributeType)) {
      const defaultValues: string[] = []
      specAttributeValueForScpVOList.forEach(
        (item: SpecAttributeValueForScpVO) => {
          if (item.selected) {
            defaultValues.push(item.specAttributeValueCode)
          }
        },
      )
      attributeBindForm.setFieldsValue({
        [`${record.specAttributeCode}_value`]: defaultValues,
      })
      return (
        <Select
          mode="multiple"
          allowClear
          placeholder="请选择属性值"
          style={{ width: '100%' }}
          defaultValue={attributeBindForm.getFieldValue(
            `${record.specAttributeCode}_value`,
          )}
          onChange={(values: any[]) => {
            attributeBindForm.setFieldsValue({
              [`${record.specAttributeCode}_value`]: values,
            })
          }}
          options={record.specAttributeValueForScpVOList}
          fieldNames={{
            value: 'specAttributeValueCode',
            label: 'specAttributeValueName',
          }}
        />
      )
    }
    if (
      attributeTypeEnum.isLabelsMatchValue(
        ['文本', '数值'],
        record.attributeType,
      )
    ) {
      const defaultValues: string[] = []
      specAttributeValueForScpVOList.forEach(
        (item: SpecAttributeValueForScpVO) => {
          if (item.selected) {
            defaultValues.push(item.specAttributeValueCode)
          }
        },
      )
      attributeBindForm.setFieldsValue({
        [`${record.specAttributeCode}_value`]: defaultValues,
      })
      return (
        <CustomMultiSelect
          defaultValue={attributeBindForm.getFieldValue(
            `${record.specAttributeCode}_value`,
          )}
          onChange={(value: any[]) => {
            attributeBindForm.setFieldsValue({
              [`${record.specAttributeCode}_value`]: value,
            })
          }}
          attributeType={record.attributeType}
          onAddTag={async (tagName: string) => {
            // 这里调用后端接口添加标签
            // 模拟接口调用
            const res = await POST_SAVE_SPEC_ATTRIBUTE_VALUE_AND_RETURN_CODE({
              platformCode: projectCode,
              specAttributeCode: record.specAttributeCode,
              wordCode: form.getFieldValue(specialField.productWord),
              specAttributeValueName: tagName,
            })
            if (!res.code) {
              return {
                id: res.data,
                label: tagName,
              }
            } else {
              return {
                id: '',
                label: tagName,
              }
            }
          }}
          record={record}
        />
      )
    }
    // 默认返回输入框
    return (
      <Input
        placeholder="请输入属性值"
        defaultValue={attributeBindForm.getFieldValue(
          `${record.specAttributeCode}_value`,
        )}
        onChange={(e) => {
          attributeBindForm.setFieldsValue({
            [`${record.specAttributeCode}_value`]: e.target.value,
          })
        }}
      />
    )
  }

  // 保存所有属性绑定
  const handleSaveAllAttributes = async () => {
    await attributeBindForm.validateFields()
    let resultValue: string[] = []
    attributeBindData.forEach((item) => {
      const value = attributeBindForm.getFieldValue(
        `${item.specAttributeCode}_value`,
      )
      if (
        (Array.isArray(value) && value.length > 0) ||
        (!Array.isArray(value) && value)
      ) {
        if (
          attributeTypeEnum.isLabelsMatchValue(['单选'], item.attributeType)
        ) {
          resultValue = resultValue.concat([value])
        }
        if (
          attributeTypeEnum.isLabelsMatchValue(['多选'], item.attributeType)
        ) {
          resultValue = resultValue.concat(value)
        }
        if (
          attributeTypeEnum.isLabelsMatchValue(
            ['文本', '数值'],
            item.attributeType,
          )
        ) {
          resultValue = resultValue.concat([value?.[0]?.id])
        }
      }
    })

    // 检查是否有属性值
    if (resultValue.length === 0) {
      message.error('请至少设置一个属性值')
      return
    }
    setAttributeBindLoading(true)
    form.setFieldsValue({
      [specialField.attribute]: resultValue.join(','),
    })
    message.success('属性绑定保存成功')
    setAttributeBindVisible(false)
    setAttributeBindLoading(false)
    setAttributeBindData([])
    attributeBindForm.resetFields()
  }

  // 关闭属性绑定弹框
  const onCancelAttributeBind = () => {
    setAttributeBindVisible(false)
    setAttributeBindLoading(false)
    setAttributeBindData([])
    attributeBindForm.resetFields()
  }

  // 打开批量上传弹框
  const onClickBatch = () => {
    setBatchVisibleAction(true)
  }

  // 关闭批量上传弹框
  const onCancelBatch = () => {
    setBatchVisibleAction(false)
    qualityList.resetFields()
    setUploadFileDataAction([])
  }

  // 提交批量上传
  const onSaveBatch = async () => {
    const qualityData = await qualityList.validateFields()
    setUploadLoading(true)
    const data = uploadFileData.map((item) => {
      return {
        ...item,
        sourceType: qualityData.sourceType,
      }
    })
    const resultData = [...qualityDataList, ...data]
    // 上传成功后，将上传的图片添加到已保存的图片中
    setQualityDataListAction(resultData)
    setUploadLoading(false)
    onCancelBatch()
  }
  // 修改批量上传的data
  const changeFileData = (data: QualityList[]) => {
    setUploadFileDataAction(data)
  }

  // 删除图片
  const handleDeleteImage = (url: string) => {
    const newFileData = qualityDataList.filter((item) => item.url !== url)
    setQualityDataListAction(newFileData)
  }

  // 通过类目获取产品词
  const getProductWord = async (categoryCode: string) => {
    const res = await GET_LIST_WORD({ platformCode: projectCode, categoryCode })
    if (!res.code) {
      setProductWordList(res.data)
    }
  }

  // 点击属性绑定获取属性及属性值列表数据
  const handleAttributeBind = async (selectIds: string) => {
    await form.validateFields([specialField.category, specialField.productWord])
    setAttributeBindVisible(true)
    setAttributeBindLoading(true)
    const selectIdsArray = selectIds.split(',')
    const res = await GET_SPEC_ATTRIBUTE_VALUE_LIST({
      platformCode: projectCode,
      categoryCode: form.getFieldValue(specialField.category),
      wordCode: form.getFieldValue(specialField.productWord),
      selectedValueCodes: selectIdsArray,
    })
    if (!res.code) {
      specAttributeListCache.current.set(
        getSpecAttributeCacheKey(
          form.getFieldValue(specialField.category),
          form.getFieldValue(specialField.productWord),
        ),
        Promise.resolve(res.data),
      )
      const data = res.data.sort((a, b) => {
        // 将required为true的排在前面
        if (a.required === '1' && b.required === '0') return -1
        if (a.required === '0' && b.required === '1') return 1
        return 0
      })

      setAttributeBindData(data)
      setAttributeBindLoading(false)
    }
  }

  // 获取属性是否必填
  const getAttributeRequired = async (
    categoryCode: string,
    wordCode: string,
  ) => {
    const res = await POST_IS_REQUIRED_SPEC_ATTRIBUTE_FOR_SUBMIT({
      platformCode: projectCode,
      categoryCode,
      wordCode,
    })
    if (!res.code) {
      setAttributeRequired(res.data)
    }
  }

  // 返回未绑定值的必填属性名：属性列表走缓存，是否绑定按当前已选编码判断。
  // 没有产品词字段的平台只按类目查；类目或产品词未选时交给它们自己的必填校验
  const getUnboundRequiredAttributes = async (selectIds: string) => {
    const categoryCode = form.getFieldValue(specialField.category)
    const wordCode = specialField.productWord
      ? form.getFieldValue(specialField.productWord)
      : undefined
    if (!categoryCode || (specialField.productWord && !wordCode)) return []
    const cacheKey = getSpecAttributeCacheKey(categoryCode, wordCode)
    let attributes = specAttributeListCache.current.get(cacheKey)
    if (!attributes) {
      attributes = GET_SPEC_ATTRIBUTE_VALUE_LIST({
        platformCode: projectCode,
        categoryCode,
        wordCode,
      }).then(
        (res) => (res.code ? undefined : res.data),
        () => undefined,
      )
      specAttributeListCache.current.set(cacheKey, attributes)
    }
    const data = await attributes
    // 查询失败不缓存，也不拦提交
    if (!data) {
      if (specAttributeListCache.current.get(cacheKey) === attributes) {
        specAttributeListCache.current.delete(cacheKey)
      }
      return []
    }
    return findUnboundRequiredAttributes(data, selectIds.split(','))
  }
  // 工具函数：设置隐藏字段值
  const setHiddenFieldValue = (
    form: FormInstance,
    projectCode: string,
    fieldKey: string,
    value: string,
  ) => {
    form.setFieldsValue({
      [`${projectCode}_${fieldKey}_name`]: value,
    })
  }

  // 触发关联字段计算：从 form 取值并调用外部回调
  const triggerRelateFieldCalc = (fieldKey: string) => {
    if (!relateFieldKeySet?.has(fieldKey) || !onRelateFieldBlur) return
    const value = form.getFieldValue(`${projectCode}_${fieldKey}`)
    onRelateFieldBlur(fieldKey, value)
  }

  // 渲染品牌选择器
  const renderBrandSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 直接使用订阅值，避免渲染时读取值滞后一拍
    const categoryCode = categoryWatch
    // 当 categoryCode 为空时，禁用品牌选择
    const isBrandDisabled = !categoryCode || readOnly

    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}_name`}
          initialValue={field.fieldValueName}
          rules={[
            {
              required: isDetailPage ? false : field.required,
              message: '请选择品牌',
            },
          ]}
          extra={fieldError}
        >
          <BrandSelect
            //  disabled={true}
            //  platformCode={projectCode}
            //  categoryCode={categoryCode}
            // disabled={isBrandDisabled}
            platformCode={projectCode}
            disabled={readOnly}
            placeholder={field.description}
            displayCode={aeccBrandField ? aeccBrandCodeWatch : undefined}
            postOnChange={(record) => {
              form.setFieldsValue({
                [`${projectCode}_${field.fieldKey}`]: record?.brandCode,
                [`${projectCode}_${field.fieldKey}_name`]: record?.brandName,
              })
            }}
          ></BrandSelect>
        </Form.Item>
        <Form.Item name={`${projectCode}_${field.fieldKey}`} noStyle initialValue={field.fieldValue}>
          <Input hidden />
        </Form.Item>
      </Col>
    )
  }

  // 人工选择和采用 AI 推荐共用的类目联动：清空产品词与属性，回填名称和折扣率
  const applyCategorySelection = (
    fieldKey: string,
    categoryCode: string,
    categoryName?: string,
    discountRate?: string,
  ) => {
    form.setFieldValue(specialField.productWord, '')
    form.setFieldValue(specialField.attribute, '')
    if (categoryName) {
      setHiddenFieldValue(form, projectCode, fieldKey, `${categoryName}/${categoryCode}`)
    }
    form.setFieldValue(`${projectCode}_${fieldKey}_rate`, discountRate)
  }

  // 选中推荐类目：AI 可能给出平台类目库里已不存在的类目，必须校验后才允许选中
  const selectRecommendedCategory = async (
    fieldKey: string,
    categoryCode: string,
  ) => {
    const item = recommend.items.find(
      (recommendItem) => recommendItem.categoryCode === categoryCode,
    )
    if (!item) return
    recommend.hideRecommendations()
    // 先登记，采用与否只看用户点没点推荐项；后面的类目池校验只影响能不能选中
    rememberProjectCategoryAdoption({
      platformCode: projectCode,
      fieldKey,
      requestId: recommend.requestId,
      categoryCode: item.categoryCode,
    })
    let matched: CategoryInfoVO | undefined
    try {
      const res = await GET_CATEGORY_POOL({
        platformCode: projectCode,
        name: item.leafName?.trim() || undefined,
      })
      matched = (res.data || []).find(
        (category: CategoryInfoVO) => category.code === item.categoryCode,
      )
    } catch {
      // 查不到按不存在处理，下面统一报错
    }
    if (!matched) {
      form.setFieldValue(`${projectCode}_${fieldKey}`, undefined)
      // 没选中就不算采用，撤销刚才的登记
      forgetProjectCategoryAdoption(projectCode, fieldKey)
      message.error(
        `推荐类目「${item.leafName}」不在当前项目类目库中，请搜索选择其他类目`,
      )
      return
    }    setCategoryList((list) =>
      list.some((existing) => existing.code === item.categoryCode)
        ? list
        : [matched!, ...list],
    )
    applyCategorySelection(
      fieldKey,
      item.categoryCode,
      matched.name,
      matched.discountRate,
    )
  }

  // 推荐请求只带已填写的物料信息；物料名称为空时控件自身不发请求
  const collectRecommendMaterial = (): ProjectCategoryRecommendationMaterial => {
    const brandField = extendedInfoList.find(
      (item) => item.fieldMeaning === FIELD_MEANING.BRAND,
    )
    const attributes = extendedInfoList
      .filter(
        (item) =>
          item.fieldKey &&
          item.fieldMeaning !== FIELD_MEANING.BRAND &&
          item.fieldMeaning !== FIELD_MEANING.CATEGORY &&
          item.fieldMeaning !== FIELD_MEANING.PRODUCT_WORD &&
          item.fieldMeaning !== FIELD_MEANING.ATTRIBUTE_CODE,
      )
      .map((item) => ({
        name: item.fieldName,
        value: form.getFieldValue(`${projectCode}_${item.fieldKey}`),
      }))
      .filter((item) => typeof item.value === 'string' && item.value.trim())
    return {
      // 新建提报填在主要信息的 name，编辑已有提报单由详情回显到 materialName
      productName:
        normalForm.getFieldValue('name') ||
        normalForm.getFieldValue('materialName') ||
        '',
      brand: brandField
        ? form.getFieldValue(`${projectCode}_${brandField.fieldKey}_name`)
        : undefined,
      attributes,
    }
  }

  // 1. 先确保你已经在组件顶部定义了防抖函数（放在函数组件内部）
  const debouncedCategorySearch = useRef(
    debounce((searchValue: string) => {
      getCategoryPool(searchValue) // 带 name 参数请求
    }, 500),
  ).current

  const recommend = useProjectCategoryRecommend({
    platformCode: projectCode,
    getMaterial: collectRecommendMaterial,
    onWarning: (text) => message.warning(text),
  })

  // 渲染类目选择器
  const renderCategorySelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 折扣展示：优先用下拉选择带过来的 _rate，没有则用字段默认 discountRate
    const _rate = form.getFieldValue(`${projectCode}_${field.fieldKey}_rate`)
    const displayRate = _rate ?? field.discountRate ?? ''
    const showRecommendButton = recommend.enabled && !isDetailPage
    // 等待和失败都借类目框的占位文案提示（PRD 4.5.1）
    const recommendPlaceholder = recommend.loading ? (
      <span className={RecommendStyle.recommendPlaceholder}>
        <Spin size="small" />
        {RECOMMEND_LOADING_TEXT}
      </span>
    ) : recommend.failed ? (
      RECOMMEND_FAILED_TEXT
    ) : undefined

    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              required: isDetailPage ? false : field.required,
              message: '请选择类目',
            },
          ]}
          extra={
            fieldError || showRate === '1' || showRecommendButton ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {fieldError && <div>{fieldError}</div>}
                {/* 智能推荐按钮紧贴类目框下方，折扣显示在按钮下面（PRD 4.5.1） */}
                {showRecommendButton && (
                  <div className={RecommendStyle.recommendButton}>
                    <Button
                      type="primary"
                      size="small"
                      icon={<BulbOutlined />}
                      disabled={readOnly || recommend.loading}
                      onClick={recommend.recommend}
                    >
                      智能推荐
                    </Button>
                  </div>
                )}
                {showRate === '1' && (
                  <div style={{ marginTop: 4, minHeight: 22 }}>
                    <ExclamationCircleOutlined style={{ marginRight: 4 }} />
                    折扣：{`${displayRate || '--'}%`}
                  </div>
                )}
              </div>
            ) : null
          }
        >
          <Select
            placeholder={recommendPlaceholder || field.description}
            allowClear
            showSearch
            filterOption={false}
            open={recommend.enabled ? recommend.open : undefined}
            optionLabelProp="label"
            // 推荐行有四列，浮层不能跟着窄列宽；人工搜索时仍与输入框等宽
            dropdownMatchSelectWidth={
              recommend.showingRecommendations ? 900 : true
            }
            onDropdownVisibleChange={(visible) => {
              if (!recommend.enabled) return
              // 本次推荐没有结果时，用户再点开下拉框应回到人工搜索结果，
              // 而不是停在"推荐功能失效"的空列表上
              if (visible && !recommend.loading && !recommend.items.length) {
                recommend.hideRecommendations()
              }
              recommend.setOpen(visible)
            }}
            onSearch={(value) => {
              // 人工搜索优先，下拉框让位给搜索结果
              recommend.hideRecommendations()
              debouncedCategorySearch(value)
            }}
            onSelect={(value: any) => {
              recommend.setOpen(false)
              // onChange 只在值变化时触发，点中"已选中的推荐类目"不会走到；用 onSelect 兜住
              const recommended = recommend.items.find(
                (item) => item.categoryCode === value,
              )
              if (recommended && recommend.requestId) {
                selectRecommendedCategory(field.fieldKey!, value)
              }
            }}
            onChange={(value) => {
              recommend.setOpen(false)
              // 推荐项已由 onSelect 处理，这里只管人工选择和清空
              const recommended = recommend.items.find(
                (item) => item.categoryCode === value,
              )
              if (recommended && recommend.requestId) return
              // 改成人工选择的类目或清空，撤销之前登记的采用
              forgetProjectCategoryAdoption(projectCode, field.fieldKey!)
              const item = categoryList.find((item) => item.code === value)
              applyCategorySelection(
                field.fieldKey!,
                value,
                item?.name,
                item?.discountRate,
              )
            }}
            disabled={readOnly}
            notFoundContent={
              recommend.loading ? (
                <div
                  className={`${RecommendStyle.recommendTip} ${RecommendStyle.recommendTipLoading}`}
                >
                  <Spin size="small" />
                  <span>{RECOMMEND_LOADING_TEXT}</span>
                </div>
              ) : recommend.failed ? (
                <div className={RecommendStyle.recommendTip}>
                  {RECOMMEND_FAILED_TEXT}
                </div>
              ) : (
                '无匹配类目'
              )
            }
          >
            {recommend.showingRecommendations
              ? recommend.items.map((item) => (
                  <Select.Option
                    key={item.categoryCode}
                    value={item.categoryCode}
                    label={`${item.categoryCode} ${item.leafName}`}
                  >
                    <div className={RecommendStyle.recommendOption}>
                      <span className={RecommendStyle.recommendPath}>
                        {item.fullPath}
                      </span>
                      <span className={RecommendStyle.recommendLeaf}>
                        {item.leafName}
                      </span>
                      <span className={RecommendStyle.recommendCode}>
                        {item.categoryCode}
                      </span>
                      <span className={RecommendStyle.recommendConfidence}>
                        匹配置信度 {(item.confidence * 100).toFixed(1)}%
                      </span>
                    </div>
                  </Select.Option>
                ))
              : categoryList.map((item) => (
                  <Select.Option
                    key={item.code}
                    value={item.code}
                    label={item.name + '/' + item.code}
                  >
                    {item.name + '/' + item.code}
                  </Select.Option>
                ))}
          </Select>
        </Form.Item>
        <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
          <Input hidden />
        </Form.Item>
        {/* 存储折扣的：默认值为字段 discountRate，下拉选择后更新为选中类目的 discountRate */}
        <Form.Item
          name={`${projectCode}_${field.fieldKey}_rate`}
          initialValue={field.discountRate}
          noStyle
        >
          <Input hidden />
        </Form.Item>
      </Col>
    )
  }
  // 渲染产品词选择器
  const renderProductWordSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => (
    <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
      <Form.Item
        label={field.fieldName}
        name={`${projectCode}_${field.fieldKey}`}
        initialValue={field.fieldValue}
        rules={[
          {
            // 必填规则: 类目下是否存在产品词
            // 配置数据的优先级高于必填规则
            required: isDetailPage
              ? false
              : field.required
                ? !form.getFieldValue(specialField.category) ||
                  (form.getFieldValue(specialField.category) &&
                    productWordList?.length > 0)
                : false,
            message: '请选择产品词',
          },
        ]}
        extra={fieldError}
      >
        <Select
          placeholder={field.description}
          allowClear
          showSearch
          filterOption={(input, option: any) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={(value) => {
            const item = productWordList?.find(
              (item) => item.wordCode === value,
            )
            form.setFieldValue(specialField.attribute, '') // 类目值发生变化清空产品词
            if (item) {
              setHiddenFieldValue(
                form,
                projectCode,
                field.fieldKey!,
                `${item.wordName}/${item.wordCode}`,
              )
            }
            getAttributeRequired(
              form.getFieldValue(specialField.category),
              value,
            )
          }}
          disabled={readOnly}
        >
          {productWordList?.map((item) => (
            <Select.Option key={item.wordCode} value={item.wordCode}>
              {item.wordName + '/' + item.wordCode}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
        <Input hidden />
      </Form.Item>
    </Col>
  )

  // 渲染属性词选择器
  const renderAttributeSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => (
    <Col
      span={8}
      key={`${projectCode}_${field.fieldKey}`}
      style={{ display: 'flex' }}
    >
      <Tooltip title={form.getFieldValue(`${projectCode}_${field.fieldKey}`)}>
        <Form.Item
          style={{ width: '80%' }}
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              // 必填规则: 类目和产品词作为参数查询是否存在属性相关数据
              // 配置数据的优先级高于必填规则
              required: isDetailPage
                ? false
                : field.required
                  ? attributeRequired
                  : false,
              message: '请选择属性词',
            },
            // 航发提交时校验必填属性都已绑定属性值，不依赖是否打开过属性绑定弹框；
            // 其他平台不校验，按类目查属性值可能多达数万条
            ...(!isDetailPage && projectCode === '132'
              ? [
                  {
                    validator: async (_: any, value: any) => {
                      const unbound = await getUnboundRequiredAttributes(
                        value || '',
                      )
                      if (unbound.length) {
                        throw new Error(`请绑定必填属性：${unbound.join('、')}`)
                      }
                    },
                  },
                ]
              : []),
          ]}
          extra={fieldError}
        >
          <Input disabled placeholder={field.description} />
        </Form.Item>
      </Tooltip>
      <Button
        type="link"
        onClick={() => {
          handleAttributeBind(
            form.getFieldValue(`${projectCode}_${field.fieldKey}`) || '',
          )
        }}
        disabled={readOnly}
      >
        属性绑定
      </Button>
    </Col>
  )

  // 渲染下拉选择器
  const renderSelect = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    const isDisabled = disabledStates[field.fieldKey!] || false

    // 被关联字段可编辑时必须必填
    const isRequired =
      field.fieldKey &&
      isDisabled === false && // 可编辑状态
      disabledStates.hasOwnProperty(field.fieldKey) // 是否为被关联字段

    const isShowTooltip = field.description && field.description?.length > 20
    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={
            isShowTooltip ? (
              <Tooltip
                title={field.description}
                getPopupContainer={() => document.body}
              >
                {field.fieldName}
              </Tooltip>
            ) : (
              field.fieldName
            )
          }
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={
            field.fieldEnumValueList?.length
              ? matchEnumOption(field, field.fieldValue)?.value
              : field.fieldValue
          }
          rules={[
            {
              required: isDetailPage
                ? false
                : isDisabled
                  ? false
                  : isRequired || field.required,
              message: `请输入${field.fieldName}`,
            },
          ]}
          extra={fieldError}
        >
          <Select
            placeholder={field.description}
            getPopupContainer={() => document.body}
            disabled={isDisabled || readOnly}
            allowClear
            showSearch
            optionFilterProp="children"
            onChange={(value: string) => {
              const item = field.fieldEnumValueList?.find(
                (item) => item.value === value,
              )
              form.setFieldValue(
                `${projectCode}_${field.fieldKey}_name`,
                item?.label,
              )
            }}
          >
            {field.fieldEnumValueList?.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
          <Input hidden />
        </Form.Item>
      </Col>
    )
  }

  const debouncedSearch = useRef(
    debounce((value: string) => {
      getThirdProductCodeList(value)
    }, 500),
  ).current

  // 渲染标准库物料编码选择器（管网主数据编码、南水北调标品编码等）
  const renderThirdProductCodeSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => (
    <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
      <Form.Item
        label={field.fieldName}
        name={`${projectCode}_${field.fieldKey}`}
        initialValue={field.fieldValue}
        rules={[
          {
            required: isDetailPage ? false : field.required,
            message: field.customErrorMsg ?? `请选择${field.fieldName}`,
          },
        ]}
        extra={fieldError}
      >
        <Select
          placeholder={field.description}
          allowClear
          showSearch
          filterOption={false} // ⚠️ 关键：关闭本地过滤，由后端处理
          // filterOption={(input, option: any) =>
          //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          // }
          onSearch={(value) => {
            setThirdProductSearchName(value)
            debouncedSearch(value)
          }}
          onChange={(value) => {
            const item: any = thirdProductCodeList.find(
              (item) => item.materialCode === value,
            )
            form.setFieldValue(`${projectCode}_${field.fieldKey}`, value)
            form.setFieldValue(
              `${projectCode}_${field.fieldKey}_name`,
              item?.materialName + '/' + item?.materialCode,
            )
          }}
          disabled={readOnly}
          notFoundContent={
            thirdProductSearchName ? '无匹配数据' : '请输入关键词搜索'
          }
        >
          {thirdProductCodeList.map((item) => (
            <Select.Option key={item.materialCode} value={item.materialCode}>
              {item.materialName + '/' + item.materialCode}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
        <Input hidden />
      </Form.Item>
    </Col>
  )

  // 国铁商城 链接销量渲染（输入框与查询按钮一体，样式参考图示）
  const renderLinkSale = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              required: isDetailPage ? false : field.required,
              message: '请选择管网主数据编码',
            },
          ]}
          extra={fieldError}
        >
          <Input
            placeholder={field.description}
            addonAfter={
              <Button
                type="link"
                style={{ padding: 0, height: 'auto' }}
                onClick={() => {
                  console.log('查询')
                }}
              >
                查询
              </Button>
            }
          />
        </Form.Item>
      </Col>
    )
  }

  // 渲染普通输入框
  const renderInput = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 使用抽取出来的关联字段逻辑
    const isDisabled = disabledStates[field.fieldKey!] || false
    const isRequired =
      field.fieldKey &&
      isDisabled === false &&
      disabledStates.hasOwnProperty(field.fieldKey)
    const fieldName = `${projectCode}_${field.fieldKey}`

    // NUMBER_STRING：后端期望“数字字符串”（保留前导 0），不能用 InputNumber。
    // 这里统一把输入过滤为纯数字，并在配置了 fieldLength 时裁剪到固定长度，避免表单中出现非法字符或超长值。
    const sanitizeNumberString = (raw: string) => {
      const digitsOnly = (raw ?? '').replace(/\D/g, '')
      if (!field.fieldLength || field.fieldLength <= 0) return digitsOnly
      return digitsOnly.slice(0, field.fieldLength)
    }

    // 不给 InputNumber 设 max：失焦时越界值会被静默改成边界值，用户看不到报错
    const numberRange = NUMBER_RANGE_CONTROL_TYPES.includes(field.controlType!)
      ? parseNumberRange(field.numberRange)
      : undefined

    const isShowTooltip = field.description && field.description?.length > 20
    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={
            isShowTooltip ? (
              <Tooltip
                title={field.description}
                getPopupContainer={() => document.body}
              >
                {field.fieldName}
              </Tooltip>
            ) : (
              field.fieldName
            )
          }
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              required: isDetailPage
                ? false
                : isDisabled
                  ? false
                  : isRequired || field.required,
              message: field.customErrorMsg ?? `请输入${field.fieldName}`,
            },
            ...(field.controlType === CONTROL_TYPE.NUMBER_STRING
              ? [
                  {
                    validator: async (_: any, value: any) => {
                      if (value === undefined || value === null || value === '')
                        return
                      const text = String(value)
                      if (!/^\d+$/.test(text)) {
                        throw new Error('只能输入数字')
                      }
                      if (
                        field.fieldLength &&
                        field.fieldLength > 0 &&
                        text.length !== field.fieldLength
                      ) {
                        throw new Error(
                          field.customErrorMsg ??
                            `只能输入${field.fieldLength}位数字`,
                        )
                      }
                    },
                  },
                ]
              : []),
            ...(numberRange
              ? [
                  {
                    validator: async (_: any, value: any) => {
                      const error = checkNumberRange(
                        value,
                        numberRange,
                        field.fieldName,
                      )
                      if (error) throw new Error(error)
                    },
                  },
                ]
              : []),
          ]}
        >
          {(() => {
            switch (field.controlType) {
              case CONTROL_TYPE.NUMBER:
                return (
                  <InputNumber
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    precision={2}
                    min={0}
                    className={
                      isDisabled || readOnly
                        ? Style.disabledInputNumber
                        : undefined
                    }
                    style={{ width: '100%' }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              case CONTROL_TYPE.INTEGER:
                return (
                  <InputNumber
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    precision={0}
                    className={
                      isDisabled || readOnly
                        ? Style.disabledInputNumber
                        : undefined
                    }
                    style={{ width: '100%' }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              case CONTROL_TYPE.POSITIVE_INTERGE:
                return (
                  <InputNumber
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    precision={0}
                    min={1}
                    className={
                      isDisabled || readOnly
                        ? Style.disabledInputNumber
                        : undefined
                    }
                    style={{ width: '100%' }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              case CONTROL_TYPE.NUMBER_STRING:
                return (
                  <Input
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    // 移动端优先弹数字键盘；PC 端仍以 onChange 过滤为准
                    inputMode="numeric"
                    pattern="[0-9]*"
                    // 配合 onChange 裁剪：限制输入位数（用于数字字符串，例如编码类字段）
                    maxLength={field.fieldLength || undefined}
                    onChange={(e) => {
                      // 强制过滤非数字并在配置 fieldLength 时裁剪到固定长度，再回写表单值
                      const next = sanitizeNumberString(e.target.value)
                      form.setFieldValue(fieldName, next)
                    }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              default:
                return (
                  <Input
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    maxLength={field.fieldLength || undefined}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
            }
          })()}
        </Form.Item>
      </Col>
    )
  }

  // 渲染单个字段
  const renderField = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 字段验证
    if (!field.fieldKey || !field.fieldName) {
      console.warn('字段配置不完整:', field)
      return null
    }

    // 品牌选择器
    if (field.fieldMeaning === FIELD_MEANING.BRAND) {
      return renderBrandSelector(field, projectCode, form, fieldError)
    }

    // 类目选择器
    if (field.fieldMeaning === FIELD_MEANING.CATEGORY) {
      return renderCategorySelector(field, projectCode, form, fieldError)
    }

    // 产品词选择器
    if (field.fieldMeaning === FIELD_MEANING.PRODUCT_WORD) {
      return renderProductWordSelector(field, projectCode, form, fieldError)
    }

    // 属性词选择器
    if (field.fieldMeaning === FIELD_MEANING.ATTRIBUTE_CODE) {
      return renderAttributeSelector(field, projectCode, form, fieldError)
    }

    if (field.fieldMeaning === FIELD_MEANING.THIRD_PRODUCT_CODE) {
      return renderThirdProductCodeSelector(
        field,
        projectCode,
        form,
        fieldError,
      )
    }

    if (
      field.fieldMeaning !== FIELD_MEANING.BRAND &&
      field.fieldMeaning !== FIELD_MEANING.CATEGORY &&
      field.fieldMeaning !== FIELD_MEANING.PRODUCT_WORD &&
      field.fieldMeaning !== FIELD_MEANING.THIRD_PRODUCT_CODE &&
      field.controlType === CONTROL_TYPE.SELECT
    ) {
      return renderSelect(field, projectCode, form, fieldError)
    }

    // 电能e购 31 平台时 且  fieldKey 为 convertScale 时 requireMessage 为 换算比例字段必填，请检查后重试

    // if()

    // 默认输入框
    return renderInput(field, projectCode, form, fieldError)
  }

  // 启用 AI 推荐的平台，类目字段连同下方的推荐按钮一起排到最后（PRD 4.5.1）
  const orderedFieldList = useMemo(() => {
    if (!recommend.enabled) return extendedInfoList
    const categoryFields = extendedInfoList.filter(
      (field) => field.fieldMeaning === FIELD_MEANING.CATEGORY,
    )
    if (!categoryFields.length) return extendedInfoList
    return [
      ...extendedInfoList.filter(
        (field) => field.fieldMeaning !== FIELD_MEANING.CATEGORY,
      ),
      ...categoryFields,
    ]
  }, [extendedInfoList, recommend.enabled])

  const handleDownload = async (
    downloadType: 'category' | 'brand' | 'standardLibrary',
  ) => {
    const downloadMap = {
      category: POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
      brand: POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
      standardLibrary: POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
    }
    const res = await downloadMap[downloadType]({ platformCode: projectCode })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }

  return (
    <Spin spinning={loading}>
      {extendedInfoList.length > 0 ? (
        <div className={Style.sectionContainer}>
          <Row gutter={16}>
            {orderedFieldList.map((field) => {
              const fieldError = field.fieldKey
                ? preCheckErrors?.extendedAttributeError?.[
                    field.fieldKey as string
                  ]
                : undefined
              const fieldErrorElement = fieldError ? (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {fieldError}
                </div>
              ) : null
              return renderField(field, projectCode, form, fieldErrorElement)
            })}

            {validationInfo}
          </Row>
        </div>
      ) : null}
      <Form
        form={normalForm}
        {...formItemLayout}
        labelAlign="right"
        style={{ margin: '0 0 16px 0' }}
        colon={false}
      >
        {projectCode === '46' && isShowSaleInfo ? (
          <div className={Style.sectionContainer}>
            <div className={Style.sectionTitle}>销售审核</div>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="saleJobNumber"
                  label="销售员"
                  rules={[
                    {
                      required: !isDetailPage,
                      message: '请选择销售员',
                    },
                  ]}
                >
                  <Select
                    disabled={readOnly}
                    showSearch
                    optionFilterProp="name"
                    placeholder="请选择销售人员"
                    options={wuhanSalePersonList}
                    onChange={(value: string) => {
                      const item = wuhanSalePersonList.find(
                        (item) => item.jobNumber === value,
                      )
                      normalForm.setFieldsValue({
                        saleName: item?.name,
                        saleJobNumber: item?.jobNumber,
                      })
                    }}
                    fieldNames={{ label: 'name', value: 'jobNumber' }}
                  />
                </Form.Item>
                <Form.Item name="saleName" label="销售员名称" noStyle>
                  <Input hidden />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="saleRemark"
                  label="提报备注"
                  rules={[
                    {
                      required: !isDetailPage,
                      message: '请输入提报备注',
                    },
                  ]}
                >
                  <Input placeholder="请输入提报备注" disabled={readOnly} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        ) : null}
      </Form>
      {/* 商品资质图片 */}
      <div className={Style.sectionContainer}>
        <div className={Style.sectionTitle}>
          <Tooltip
            title="最多支持十条资质信息"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined />
          </Tooltip>
          商品资质图片
          <Button
            type="primary"
            size="small"
            className={Style.uploadButton}
            onClick={onClickBatch}
            disabled={readOnly}
          >
            上传资质图片
          </Button>
        </div>
        <Table
          rowKey="url"
          dataSource={qualityDataList}
          columns={qualityColumns}
          scroll={{ y: 300 }}
          pagination={false}
        />
      </div>

      <div className={Style.sectionContainer}>
        <div className={Style.sectionTitle}>客户基础数据</div>
        <Space style={{ marginLeft: '22px' }}>
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('category')}
          >
            客户分类下载
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('brand')}
          >
            客户品牌下载
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('standardLibrary')}
          >
            客户标准库下载
          </Button>
        </Space>
      </div>

      {/* 图片预览弹窗 */}
      <PreviewUser
        images={previewimg}
        onClose={() =>
          setPreviewimg({
            data: [],
          })
        }
      />

      {/* 批量上传 */}
      <CustomModal
        title="批量上传"
        open={batchVisible}
        width={470}
        modalCancel={onCancelBatch}
        footer={
          <div className={Style.modalFooter}>
            <Button
              disabled={uploadLoading}
              type="primary"
              size="middle"
              onClick={onCancelBatch}
            >
              取消
            </Button>
            <Button
              disabled={uploadLoading}
              type="primary"
              size="middle"
              onClick={onSaveBatch}
            >
              保存
            </Button>
          </div>
        }
      >
        <Spin spinning={uploadLoading}>
          <Form form={qualityList}>
            <Form.Item
              name="sourceType"
              label="图片资质类型"
              rules={[{ required: true, message: '请选择图片资质类型' }]}
              style={{ marginBottom: 0 }}
            >
              <Select
                placeholder="请选择图片资质类型"
                style={{ width: '300px' }}
                getPopupContainer={() => document.body}
                options={qualityTypeList}
              />
            </Form.Item>
          </Form>
          <UpdateImg
            // platformCode={platformCode}
            dataSource={uploadFileData}
            onChange={changeFileData}
            setUploadLoading={setUploadLoading}
          />
        </Spin>
      </CustomModal>
      <CustomModal
        title="属性绑定"
        open={attributeBindVisible}
        width={1000}
        modalCancel={onCancelAttributeBind}
        footer={
          <div
            style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}
          >
            <Button onClick={onCancelAttributeBind}>取消</Button>
            <Button
              type="primary"
              onClick={handleSaveAllAttributes}
              loading={attributeBindLoading}
            >
              保存
            </Button>
          </div>
        }
      >
        <Spin spinning={attributeBindLoading}>
          <Form form={attributeBindForm}>
            <Table
              dataSource={attributeBindData}
              columns={attributeBindColumns}
              scroll={{ y: 300 }}
              pagination={false}
              rowKey="specAttributeId"
              className={Style.attributeTable}
            />
          </Form>
        </Spin>
      </CustomModal>
    </Spin>
  )
}

export default GoodsSubmissionInfo
/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-07-10 08:48:00
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-01-12 17:10:01
 */
import React, { useEffect, useMemo, useState } from 'react'
import { useRelateField } from '@/modules/goodsdetailmodules/goodsSubmissionInfo.tsx/useRelateField'
import Table from '@/components/CustomTable'
import {
  BulbOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import {
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  message,
  Spin,
  FormInstance,
  Tooltip,
  Space,
  InputNumber,
} from 'antd'
import CustomModal from '@/components/ModalUser'
import UpdateImg from './components/UpdateImg'
import PreviewUser from '@/components/PreviewUser'
import Style from './style.module.scss'
import CustomMultiSelect from './components/CustomMutilSelect'
import { debounce } from 'lodash'
import { useRef } from 'react'
import {
  qualityTypeList,
  qualityTypeEnum,
  reportTypeEnumValue,
  reportTypeEnum,
  shelfStatusList,
  attributeTypeEnum,
} from '@/global/enum/product'
import {
  GET_BRAND_INFO,
  BrandInfoVO,
  CategoryInfoVO,
  GET_CATEGORY_POOL,
  ProductWordInfoVO,
  SpecAttributeForScpVo,
  ExtendedInfo,
  GET_LIST_WORD,
  GET_SPEC_ATTRIBUTE_VALUE_LIST,
  POST_SAVE_SPEC_ATTRIBUTE_VALUE_AND_RETURN_CODE,
  QualityList,
  POST_IS_REQUIRED_SPEC_ATTRIBUTE_FOR_SUBMIT,
  GET_WUHAN_SALE_PERSON_LIST,
  GET_THIRD_PRODUCT_CODE_LIST,
  POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
  POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
  POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
  SpecAttributeValueForScpVO,
  ProjectCategoryRecommendationMaterial,
} from '@/api/reportApi'
import { BrandSelect } from '@/components/BrandSelect'
import {
  RECOMMEND_FAILED_TEXT,
  RECOMMEND_LOADING_TEXT,
  useProjectCategoryRecommend,
} from './components/ProjectCategoryRecommend/useProjectCategoryRecommend'
import RecommendStyle from './components/ProjectCategoryRecommend/style.module.scss'
import { isResponseCodeSuccess } from '@/tools/util'
import {
  forgetProjectCategoryAdoption,
  rememberProjectCategoryAdoption,
} from '@/tools/projectCategoryAdopt'
import { checkNumberRange, parseNumberRange } from '@/tools/numberRange'
import { findUnboundRequiredAttributes } from '@/tools/specAttribute'
import { PreCheckErrors } from '@/api/MaterialApi'

interface Props {
  extendedInfoList: ExtendedInfo[]
  projectCode: string
  form: FormInstance
  normalForm: FormInstance
  submissionType?: reportTypeEnumValue
  qualityDataList: QualityList[]
  setQualityDataListAction: (data: QualityList[]) => void
  readOnly?: boolean
  isDetailPage?: boolean // 是否是详情页面
  isShowSaleInfo?: boolean // 是否显示销售审核
  preCheckErrors?: PreCheckErrors
  showRate?: '1' | '0'
  relateFieldKeySet?: Set<string> // 需要监听 blur 的关联字段 Key 集合
  onRelateFieldBlur?: (fieldKey: string, value: any) => void // blur 回调
  validationInfo?: React.ReactNode
}

// 字段含义枚举
const FIELD_MEANING = {
  BRAND: '1', // 品牌
  CATEGORY: '2', // 类目
  PRODUCT_WORD: 'wordCode', // 产品词
  ATTRIBUTE_CODE: 'specAttributeValueCode', // 属性值编码
  THIRD_PRODUCT_CODE: 'thirdProductCode', //
} as const

// 控件类型枚举
const CONTROL_TYPE = {
  SELECT: '3',
  NUMBER: '6',
  // 整数:'7'
  INTEGER: '7',
  // 正整数:'8'
  POSITIVE_INTERGE: '8',
  // 数字字符串（为解决大额数字科学计数法问题）:9
  NUMBER_STRING: '9',
} as const

// 受 numberRange 数值范围校验的控件
const NUMBER_RANGE_CONTROL_TYPES: string[] = [
  CONTROL_TYPE.NUMBER,
  CONTROL_TYPE.INTEGER,
  CONTROL_TYPE.POSITIVE_INTERGE,
]

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}

// 提报商品详情
const GoodsSubmissionInfo: React.FC<Props> = (props) => {
  const {
    extendedInfoList,
    projectCode,
    form,
    normalForm,
    submissionType = 'NEW',
    qualityDataList = [],
    setQualityDataListAction,
    readOnly = false,
    isDetailPage = false,
    isShowSaleInfo = true,
    preCheckErrors,
    showRate,
    relateFieldKeySet,
    onRelateFieldBlur,
    validationInfo,
  } = props

  const [batchVisible, setBatchVisibleAction] = useState(false)
  // 上传的图片数据
  const [uploadFileData, setUploadFileDataAction] = useState<QualityList[]>([])
  const [uploadLoading, setUploadLoading] = useState(false)
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  const [loading, setLoading] = useState(false)
  // const [brandList, setBrandList] = useState<BrandInfoVO[]>([])
  const [categoryList, setCategoryList] = useState<CategoryInfoVO[]>([])
  const [productWordList, setProductWordList] = useState<ProductWordInfoVO[]>(
    [],
  )
  const [attributeBindVisible, setAttributeBindVisible] = useState(false)
  const [attributeBindLoading, setAttributeBindLoading] = useState(false)
  const [attributeBindData, setAttributeBindData] = useState<
    SpecAttributeForScpVo[]
  >([])
  // 属性列表按类目和产品词缓存，属性绑定弹框与提交校验共用，同一组参数只查一次
  const specAttributeListCache = useRef(
    new Map<string, Promise<SpecAttributeForScpVo[] | undefined>>(),
  )
  const getSpecAttributeCacheKey = (categoryCode: string, wordCode?: string) =>
    `${projectCode}|${categoryCode}|${wordCode || ''}`
  const [attributeRequired, setAttributeRequired] = useState<boolean>(true)
  const [specialField, setSpecialField] = useState<{
    category: string
    productWord: string
    attribute: string
  }>({
    category: '',
    productWord: '',
    attribute: '',
  })
  const [wuhanSalePersonList, setWuhanSalePersonList] = useState<any[]>([])
  const [attributeBindForm] = Form.useForm()
  const [qualityList] = Form.useForm()
  const [thirdProductCodeList, setThirdProductCodeList] = useState<any[]>([])
  const [thirdProductSearchName, setThirdProductSearchName] =
    useState<string>('')

  // const getBrandInfo = async () => {
  //   const res = await GET_BRAND_INFO({ platformCode: projectCode })
  //   setBrandList(res.data)
  // }
  // const getCategoryPool = async () => {
  //   const res = await GET_CATEGORY_POOL({ platformCode: projectCode })
  //   setCategoryList(res.data)
  // }
  // 替换原来的 getCategoryPool
  const getCategoryPool = async (searchName?: string) => {
    if (!projectCode) return
    const res = await GET_CATEGORY_POOL({
      platformCode: projectCode,
      name: searchName?.trim() || undefined, // 空字符串不传，避免后端查空字符串
    })
    setCategoryList(res.data || [])
  }

  const getWuhanSalePersonList = async () => {
    const res = await GET_WUHAN_SALE_PERSON_LIST()
    setWuhanSalePersonList(res.data)
  }
  const getThirdProductCodeList = async (searchName?: string) => {
    const res = await GET_THIRD_PRODUCT_CODE_LIST({
      platformCode: projectCode,
      name: searchName?.trim() || undefined,
    }) // 为空时不传
    setThirdProductCodeList(res.data || [])
  }
  useEffect(() => {
    setLoading(true)
    if (!projectCode) return
    // 获取品牌数据
    // getBrandInfo()
    // 获取类目数据
    getCategoryPool()
    setLoading(false)
    if (projectCode === '46') {
      getWuhanSalePersonList()
    }
    // 管网主数据编码、南水北调标品编码：进页面先加载一批标准库物料供下拉选择
    if (['46', 'WZ1863'].includes(projectCode)) {
      getThirdProductCodeList()
    }
  }, [projectCode])

  // 枚举字段回显归一：历史数据可能把中文 label 当 value 存，这里映射回 value，映射不到返回 undefined 强制重选
  const matchEnumOption = (field: ExtendedInfo, raw?: string) => {
    const options = field.fieldEnumValueList
    if (!options?.length || raw === undefined || raw === null || raw === '') {
      return undefined
    }
    return (
      options.find((option) => option.value === raw) ??
      options.find((option) => option.label === raw)
    )
  }

  useEffect(() => {
    if (!projectCode) return
    // 先处理品牌和类目的回显
    extendedInfoList?.forEach((item) => {
      const normalize = (v: any) =>
        v === '' || v === 'null' || v === null || v === undefined
          ? undefined
          : v

      if (
        item.fieldMeaning === FIELD_MEANING.BRAND ||
        item.fieldMeaning === FIELD_MEANING.CATEGORY ||
        item.controlType === CONTROL_TYPE.SELECT ||
        item.fieldMeaning === FIELD_MEANING.THIRD_PRODUCT_CODE
      ) {
        if (item.fieldMeaning === FIELD_MEANING.BRAND) {
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}_name`]: normalize(
              item.fieldValueName ||
                form.getFieldValue(`${projectCode}_${item.fieldKey}_name`),
            ),
            [`${projectCode}_${item.fieldKey}`]: normalize(
              form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
                item.fieldValue,
            ),
          })
        } else if (
          item.fieldMeaning !== FIELD_MEANING.CATEGORY &&
          item.fieldMeaning !== FIELD_MEANING.PRODUCT_WORD &&
          item.fieldMeaning !== FIELD_MEANING.THIRD_PRODUCT_CODE &&
          item.controlType === CONTROL_TYPE.SELECT &&
          item.fieldEnumValueList?.length
        ) {
          const raw =
            form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
            item.fieldValue
          const matched = matchEnumOption(item, raw)
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}`]: matched?.value,
            [`${projectCode}_${item.fieldKey}_name`]: matched?.label,
          })
        } else {
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}_name`]: normalize(
              form.getFieldValue(`${projectCode}_${item.fieldKey}_name`) ||
                item.fieldValueName,
            ),
            [`${projectCode}_${item.fieldKey}`]: normalize(
              form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
                item.fieldValue,
            ),
          })
        }
      } else {
        form.setFieldsValue({
          [`${projectCode}_${item.fieldKey}`]: normalize(
            form.getFieldValue(`${projectCode}_${item.fieldKey}`) ||
              item.fieldValue,
          ),
        })
      }
    })

    // 然后处理特殊字段的设置
    const newSpecialField = {
      category: '',
      productWord: '',
      attribute: '',
      thirdProductCode: '',
    }

    extendedInfoList?.forEach((item) => {
      if (item.fieldMeaning === FIELD_MEANING.CATEGORY) {
        // 类目字段
        newSpecialField.category = `${projectCode}_${item.fieldKey}`
      }
      if (item.fieldMeaning === FIELD_MEANING.PRODUCT_WORD) {
        // 产品词字段
        newSpecialField.productWord = `${projectCode}_${item.fieldKey}`
      }
      if (item.fieldMeaning === FIELD_MEANING.ATTRIBUTE_CODE) {
        // 产品词字段
        newSpecialField.attribute = `${projectCode}_${item.fieldKey}`
      }
      if (item.fieldMeaning === FIELD_MEANING.THIRD_PRODUCT_CODE) {
        // 管网主数据编码字段
        newSpecialField.thirdProductCode = `${projectCode}_${item.fieldKey}`
      }
    })

    setSpecialField(newSpecialField)
  }, [projectCode, extendedInfoList])
  const categoryWatch = Form.useWatch(specialField.category, form)
  // 航发品牌栏显示「中文（英文）/品牌编码」，提交的仍只是品牌名称
  const aeccBrandField =
    projectCode === '132'
      ? extendedInfoList?.find(
          (item) => item.fieldMeaning === FIELD_MEANING.BRAND,
        )
      : undefined
  const aeccBrandCodeWatch = Form.useWatch(
    aeccBrandField ? `${projectCode}_${aeccBrandField.fieldKey}` : '',
    form,
  )

  useEffect(() => {
    // specialField 还未就绪时，不执行依赖类目的联动逻辑，避免首屏误禁用/误清空
    if (!specialField.category) return
    const category = form.getFieldValue(specialField.category)
    if (category) {
      // 通过类目获取产品词
      getProductWord(category)
      const haveAttribute = extendedInfoList.some(
        (item) => item.fieldMeaning === FIELD_MEANING.ATTRIBUTE_CODE,
      )
      if (haveAttribute) {
        getAttributeRequired(
          category,
          form.getFieldValue(specialField.productWord),
        )
      }
    } else {
      // 类目数据清空,产品词清空,属性必填
      setAttributeRequired(true)
      setProductWordList([])

      // 清空所有品牌字段
      extendedInfoList?.forEach((item) => {
        if (item.fieldMeaning === FIELD_MEANING.BRAND) {
          form.setFieldsValue({
            [`${projectCode}_${item.fieldKey}`]: undefined,
            [`${projectCode}_${item.fieldKey}_name`]: undefined,
          })
        }
      })
    }
  }, [specialField, categoryWatch])

  // 使用抽取出来的关联字段 Hook
  const fieldConfigs = extendedInfoList.map((field) => ({
    fieldKey: field.fieldKey!,
    projectCode,
    relateField: field.relateField,
    relateFieldEnumValue: field.relateFieldEnumValue,
  }))

  const { disabledStates } = useRelateField(fieldConfigs, form, projectCode)

  const handlePreviewImage = (index: number) => {
    const url: string[] = []
    qualityDataList.forEach((item) => {
      if (item.url.indexOf('.pdf') === -1) {
        url.push(`${item.baseUrl}${item.url}`)
      }
    })
    setPreviewimg({
      data: url,
      currentIndex: index,
    })
  }

  // 资质图片列表
  const qualityColumns = [
    {
      title: '图片资质类型',
      key: 'sourceType',
      dataIndex: 'sourceType',
      width: 120,
      render: (text: string) => qualityTypeEnum.getLabelByValue(text),
    },
    {
      title: '图片',
      key: 'url',
      dataIndex: 'url',
      render: (text: string, record: QualityList) => {
        return text ? (
          <a onClick={() => window.open(`${record.baseUrl}${text}`)}>
            {record.baseUrl}
            {text}
          </a>
        ) : (
          '-'
        )
      },
    },
    {
      title: '操作',
      key: 'action',
      dataIndex: 'action',
      width: 200,
      render: (text: string, record: QualityList, index: number) => {
        return (
          <>
            {record.url.endsWith('.pdf') ? (
              <a
                onClick={() => window.open(`${record.baseUrl}${record.url}`)}
                style={{ marginRight: '7px' }}
              >
                点击预览
              </a>
            ) : (
              <Button type="link" onClick={() => handlePreviewImage(index)}>
                点击预览
              </Button>
            )}
            <Button
              type="link"
              onClick={() => handleDeleteImage(record.url)}
              disabled={readOnly}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]

  // 属性绑定列表
  const attributeBindColumns = [
    {
      title: '属性编码',
      key: 'specAttributeCode',
      dataIndex: 'specAttributeCode',
      width: 120,
    },
    {
      title: '属性名称',
      key: 'specAttributeName',
      dataIndex: 'specAttributeName',
      width: 150,
    },
    {
      title: '属性类型',
      key: 'attributeType',
      dataIndex: 'attributeType',
      width: 120,
      render: (text: string) => {
        return attributeTypeEnum.getLabelByValue(text)
      },
    },
    {
      title: '是否销售属性',
      key: 'isSaleAttribute',
      dataIndex: 'isSaleAttribute',
      width: 120,
      render: (text: string) => {
        return text === '1' ? '是' : '否'
      },
    },
    {
      title: '是否必填',
      key: 'required',
      dataIndex: 'required',
      width: 120,
      render: (text: string) => {
        return text === '1' ? '是' : '否'
      },
    },
    {
      title: '属性值名称',
      key: 'attributeValue',
      dataIndex: 'attributeValue',
      width: 300,
      render: (text: string, record: any) => {
        return (
          <div className={Style.attributeValueCell}>
            <Form.Item
              name={`${record.specAttributeCode}_value`}
              style={{ width: '100%', marginBottom: 0 }}
              rules={[
                { required: record.required === '1', message: '请添加属性值' },
              ]}
            >
              {renderAttribute(record, attributeBindForm)}
            </Form.Item>
          </div>
        )
      },
    },
  ]

  // 渲染属性选择器
  const renderAttribute = (record: any, attributeBindForm: FormInstance) => {
    const { specAttributeValueForScpVOList = [] } = record
    if (attributeTypeEnum.isLabelsMatchValue(['单选'], record.attributeType)) {
      const defaultValues =
        specAttributeValueForScpVOList.find(
          (item: SpecAttributeValueForScpVO) => item.selected,
        )?.specAttributeValueCode || ''

      attributeBindForm.setFieldsValue({
        [`${record.specAttributeCode}_value`]: defaultValues,
      })
      return (
        <Select
          placeholder="请选择属性值"
          allowClear
          style={{ width: '100%' }}
          // defaultValue={attributeBindForm.getFieldValue(
          //   `${record.specAttributeCode}_value`,
          // )}
          onChange={(value, option: any) => {
            // 保存选中的值和标签
            attributeBindForm.setFieldsValue({
              [`${record.specAttributeCode}_value`]: value,
            })
          }}
          options={record.specAttributeValueForScpVOList}
          fieldNames={{
            value: 'specAttributeValueCode',
            label: 'specAttributeValueName',
          }}
        />
      )
    }
    if (attributeTypeEnum.isLabelsMatchValue(['多选'], record.attributeType)) {
      const defaultValues: string[] = []
      specAttributeValueForScpVOList.forEach(
        (item: SpecAttributeValueForScpVO) => {
          if (item.selected) {
            defaultValues.push(item.specAttributeValueCode)
          }
        },
      )
      attributeBindForm.setFieldsValue({
        [`${record.specAttributeCode}_value`]: defaultValues,
      })
      return (
        <Select
          mode="multiple"
          allowClear
          placeholder="请选择属性值"
          style={{ width: '100%' }}
          defaultValue={attributeBindForm.getFieldValue(
            `${record.specAttributeCode}_value`,
          )}
          onChange={(values: any[]) => {
            attributeBindForm.setFieldsValue({
              [`${record.specAttributeCode}_value`]: values,
            })
          }}
          options={record.specAttributeValueForScpVOList}
          fieldNames={{
            value: 'specAttributeValueCode',
            label: 'specAttributeValueName',
          }}
        />
      )
    }
    if (
      attributeTypeEnum.isLabelsMatchValue(
        ['文本', '数值'],
        record.attributeType,
      )
    ) {
      const defaultValues: string[] = []
      specAttributeValueForScpVOList.forEach(
        (item: SpecAttributeValueForScpVO) => {
          if (item.selected) {
            defaultValues.push(item.specAttributeValueCode)
          }
        },
      )
      attributeBindForm.setFieldsValue({
        [`${record.specAttributeCode}_value`]: defaultValues,
      })
      return (
        <CustomMultiSelect
          defaultValue={attributeBindForm.getFieldValue(
            `${record.specAttributeCode}_value`,
          )}
          onChange={(value: any[]) => {
            attributeBindForm.setFieldsValue({
              [`${record.specAttributeCode}_value`]: value,
            })
          }}
          attributeType={record.attributeType}
          onAddTag={async (tagName: string) => {
            // 这里调用后端接口添加标签
            // 模拟接口调用
            const res = await POST_SAVE_SPEC_ATTRIBUTE_VALUE_AND_RETURN_CODE({
              platformCode: projectCode,
              specAttributeCode: record.specAttributeCode,
              wordCode: form.getFieldValue(specialField.productWord),
              specAttributeValueName: tagName,
            })
            if (!res.code) {
              return {
                id: res.data,
                label: tagName,
              }
            } else {
              return {
                id: '',
                label: tagName,
              }
            }
          }}
          record={record}
        />
      )
    }
    // 默认返回输入框
    return (
      <Input
        placeholder="请输入属性值"
        defaultValue={attributeBindForm.getFieldValue(
          `${record.specAttributeCode}_value`,
        )}
        onChange={(e) => {
          attributeBindForm.setFieldsValue({
            [`${record.specAttributeCode}_value`]: e.target.value,
          })
        }}
      />
    )
  }

  // 保存所有属性绑定
  const handleSaveAllAttributes = async () => {
    await attributeBindForm.validateFields()
    let resultValue: string[] = []
    attributeBindData.forEach((item) => {
      const value = attributeBindForm.getFieldValue(
        `${item.specAttributeCode}_value`,
      )
      if (
        (Array.isArray(value) && value.length > 0) ||
        (!Array.isArray(value) && value)
      ) {
        if (
          attributeTypeEnum.isLabelsMatchValue(['单选'], item.attributeType)
        ) {
          resultValue = resultValue.concat([value])
        }
        if (
          attributeTypeEnum.isLabelsMatchValue(['多选'], item.attributeType)
        ) {
          resultValue = resultValue.concat(value)
        }
        if (
          attributeTypeEnum.isLabelsMatchValue(
            ['文本', '数值'],
            item.attributeType,
          )
        ) {
          resultValue = resultValue.concat([value?.[0]?.id])
        }
      }
    })

    // 检查是否有属性值
    if (resultValue.length === 0) {
      message.error('请至少设置一个属性值')
      return
    }
    setAttributeBindLoading(true)
    form.setFieldsValue({
      [specialField.attribute]: resultValue.join(','),
    })
    message.success('属性绑定保存成功')
    setAttributeBindVisible(false)
    setAttributeBindLoading(false)
    setAttributeBindData([])
    attributeBindForm.resetFields()
  }

  // 关闭属性绑定弹框
  const onCancelAttributeBind = () => {
    setAttributeBindVisible(false)
    setAttributeBindLoading(false)
    setAttributeBindData([])
    attributeBindForm.resetFields()
  }

  // 打开批量上传弹框
  const onClickBatch = () => {
    setBatchVisibleAction(true)
  }

  // 关闭批量上传弹框
  const onCancelBatch = () => {
    setBatchVisibleAction(false)
    qualityList.resetFields()
    setUploadFileDataAction([])
  }

  // 提交批量上传
  const onSaveBatch = async () => {
    const qualityData = await qualityList.validateFields()
    setUploadLoading(true)
    const data = uploadFileData.map((item) => {
      return {
        ...item,
        sourceType: qualityData.sourceType,
      }
    })
    const resultData = [...qualityDataList, ...data]
    // 上传成功后，将上传的图片添加到已保存的图片中
    setQualityDataListAction(resultData)
    setUploadLoading(false)
    onCancelBatch()
  }
  // 修改批量上传的data
  const changeFileData = (data: QualityList[]) => {
    setUploadFileDataAction(data)
  }

  // 删除图片
  const handleDeleteImage = (url: string) => {
    const newFileData = qualityDataList.filter((item) => item.url !== url)
    setQualityDataListAction(newFileData)
  }

  // 通过类目获取产品词
  const getProductWord = async (categoryCode: string) => {
    const res = await GET_LIST_WORD({ platformCode: projectCode, categoryCode })
    if (!res.code) {
      setProductWordList(res.data)
    }
  }

  // 点击属性绑定获取属性及属性值列表数据
  const handleAttributeBind = async (selectIds: string) => {
    await form.validateFields([specialField.category, specialField.productWord])
    setAttributeBindVisible(true)
    setAttributeBindLoading(true)
    const selectIdsArray = selectIds.split(',')
    const res = await GET_SPEC_ATTRIBUTE_VALUE_LIST({
      platformCode: projectCode,
      categoryCode: form.getFieldValue(specialField.category),
      wordCode: form.getFieldValue(specialField.productWord),
      selectedValueCodes: selectIdsArray,
    })
    if (!res.code) {
      specAttributeListCache.current.set(
        getSpecAttributeCacheKey(
          form.getFieldValue(specialField.category),
          form.getFieldValue(specialField.productWord),
        ),
        Promise.resolve(res.data),
      )
      const data = res.data.sort((a, b) => {
        // 将required为true的排在前面
        if (a.required === '1' && b.required === '0') return -1
        if (a.required === '0' && b.required === '1') return 1
        return 0
      })

      setAttributeBindData(data)
      setAttributeBindLoading(false)
    }
  }

  // 获取属性是否必填
  const getAttributeRequired = async (
    categoryCode: string,
    wordCode: string,
  ) => {
    const res = await POST_IS_REQUIRED_SPEC_ATTRIBUTE_FOR_SUBMIT({
      platformCode: projectCode,
      categoryCode,
      wordCode,
    })
    if (!res.code) {
      setAttributeRequired(res.data)
    }
  }

  // 返回未绑定值的必填属性名：属性列表走缓存，是否绑定按当前已选编码判断。
  // 没有产品词字段的平台只按类目查；类目或产品词未选时交给它们自己的必填校验
  const getUnboundRequiredAttributes = async (selectIds: string) => {
    const categoryCode = form.getFieldValue(specialField.category)
    const wordCode = specialField.productWord
      ? form.getFieldValue(specialField.productWord)
      : undefined
    if (!categoryCode || (specialField.productWord && !wordCode)) return []
    const cacheKey = getSpecAttributeCacheKey(categoryCode, wordCode)
    let attributes = specAttributeListCache.current.get(cacheKey)
    if (!attributes) {
      attributes = GET_SPEC_ATTRIBUTE_VALUE_LIST({
        platformCode: projectCode,
        categoryCode,
        wordCode,
      }).then(
        (res) => (res.code ? undefined : res.data),
        () => undefined,
      )
      specAttributeListCache.current.set(cacheKey, attributes)
    }
    const data = await attributes
    // 查询失败不缓存，也不拦提交
    if (!data) {
      if (specAttributeListCache.current.get(cacheKey) === attributes) {
        specAttributeListCache.current.delete(cacheKey)
      }
      return []
    }
    return findUnboundRequiredAttributes(data, selectIds.split(','))
  }
  // 工具函数：设置隐藏字段值
  const setHiddenFieldValue = (
    form: FormInstance,
    projectCode: string,
    fieldKey: string,
    value: string,
  ) => {
    form.setFieldsValue({
      [`${projectCode}_${fieldKey}_name`]: value,
    })
  }

  // 触发关联字段计算：从 form 取值并调用外部回调
  const triggerRelateFieldCalc = (fieldKey: string) => {
    if (!relateFieldKeySet?.has(fieldKey) || !onRelateFieldBlur) return
    const value = form.getFieldValue(`${projectCode}_${fieldKey}`)
    onRelateFieldBlur(fieldKey, value)
  }

  // 渲染品牌选择器
  const renderBrandSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 直接使用订阅值，避免渲染时读取值滞后一拍
    const categoryCode = categoryWatch
    // 当 categoryCode 为空时，禁用品牌选择
    const isBrandDisabled = !categoryCode || readOnly

    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}_name`}
          initialValue={field.fieldValueName}
          rules={[
            {
              required: isDetailPage ? false : field.required,
              message: '请选择品牌',
            },
          ]}
          extra={fieldError}
        >
          <BrandSelect
            //  disabled={true}
            //  platformCode={projectCode}
            //  categoryCode={categoryCode}
            // disabled={isBrandDisabled}
            platformCode={projectCode}
            disabled={readOnly}
            placeholder={field.description}
            displayCode={aeccBrandField ? aeccBrandCodeWatch : undefined}
            postOnChange={(record) => {
              form.setFieldsValue({
                [`${projectCode}_${field.fieldKey}`]: record?.brandCode,
                [`${projectCode}_${field.fieldKey}_name`]: record?.brandName,
              })
            }}
          ></BrandSelect>
        </Form.Item>
        <Form.Item name={`${projectCode}_${field.fieldKey}`} noStyle initialValue={field.fieldValue}>
          <Input hidden />
        </Form.Item>
      </Col>
    )
  }

  // 人工选择和采用 AI 推荐共用的类目联动：清空产品词与属性，回填名称和折扣率
  const applyCategorySelection = (
    fieldKey: string,
    categoryCode: string,
    categoryName?: string,
    discountRate?: string,
  ) => {
    form.setFieldValue(specialField.productWord, '')
    form.setFieldValue(specialField.attribute, '')
    if (categoryName) {
      setHiddenFieldValue(form, projectCode, fieldKey, `${categoryName}/${categoryCode}`)
    }
    form.setFieldValue(`${projectCode}_${fieldKey}_rate`, discountRate)
  }

  // 选中推荐类目：AI 可能给出平台类目库里已不存在的类目，必须校验后才允许选中
  const selectRecommendedCategory = async (
    fieldKey: string,
    categoryCode: string,
  ) => {
    const item = recommend.items.find(
      (recommendItem) => recommendItem.categoryCode === categoryCode,
    )
    if (!item) return
    recommend.hideRecommendations()
    // 先登记，采用与否只看用户点没点推荐项；后面的类目池校验只影响能不能选中
    rememberProjectCategoryAdoption({
      platformCode: projectCode,
      fieldKey,
      requestId: recommend.requestId,
      categoryCode: item.categoryCode,
    })
    let matched: CategoryInfoVO | undefined
    try {
      const res = await GET_CATEGORY_POOL({
        platformCode: projectCode,
        name: item.leafName?.trim() || undefined,
      })
      matched = (res.data || []).find(
        (category: CategoryInfoVO) => category.code === item.categoryCode,
      )
    } catch {
      // 查不到按不存在处理，下面统一报错
    }
    if (!matched) {
      form.setFieldValue(`${projectCode}_${fieldKey}`, undefined)
      // 没选中就不算采用，撤销刚才的登记
      forgetProjectCategoryAdoption(projectCode, fieldKey)
      message.error(
        `推荐类目「${item.leafName}」不在当前项目类目库中，请搜索选择其他类目`,
      )
      return
    }    setCategoryList((list) =>
      list.some((existing) => existing.code === item.categoryCode)
        ? list
        : [matched!, ...list],
    )
    applyCategorySelection(
      fieldKey,
      item.categoryCode,
      matched.name,
      matched.discountRate,
    )
  }

  // 推荐请求只带已填写的物料信息；物料名称为空时控件自身不发请求
  const collectRecommendMaterial = (): ProjectCategoryRecommendationMaterial => {
    const brandField = extendedInfoList.find(
      (item) => item.fieldMeaning === FIELD_MEANING.BRAND,
    )
    const attributes = extendedInfoList
      .filter(
        (item) =>
          item.fieldKey &&
          item.fieldMeaning !== FIELD_MEANING.BRAND &&
          item.fieldMeaning !== FIELD_MEANING.CATEGORY &&
          item.fieldMeaning !== FIELD_MEANING.PRODUCT_WORD &&
          item.fieldMeaning !== FIELD_MEANING.ATTRIBUTE_CODE,
      )
      .map((item) => ({
        name: item.fieldName,
        value: form.getFieldValue(`${projectCode}_${item.fieldKey}`),
      }))
      .filter((item) => typeof item.value === 'string' && item.value.trim())
    return {
      // 新建提报填在主要信息的 name，编辑已有提报单由详情回显到 materialName
      productName:
        normalForm.getFieldValue('name') ||
        normalForm.getFieldValue('materialName') ||
        '',
      brand: brandField
        ? form.getFieldValue(`${projectCode}_${brandField.fieldKey}_name`)
        : undefined,
      attributes,
    }
  }

  // 1. 先确保你已经在组件顶部定义了防抖函数（放在函数组件内部）
  const debouncedCategorySearch = useRef(
    debounce((searchValue: string) => {
      getCategoryPool(searchValue) // 带 name 参数请求
    }, 500),
  ).current

  const recommend = useProjectCategoryRecommend({
    platformCode: projectCode,
    getMaterial: collectRecommendMaterial,
    onWarning: (text) => message.warning(text),
  })

  // 渲染类目选择器
  const renderCategorySelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 折扣展示：优先用下拉选择带过来的 _rate，没有则用字段默认 discountRate
    const _rate = form.getFieldValue(`${projectCode}_${field.fieldKey}_rate`)
    const displayRate = _rate ?? field.discountRate ?? ''
    const showRecommendButton = recommend.enabled && !isDetailPage
    // 等待和失败都借类目框的占位文案提示（PRD 4.5.1）
    const recommendPlaceholder = recommend.loading ? (
      <span className={RecommendStyle.recommendPlaceholder}>
        <Spin size="small" />
        {RECOMMEND_LOADING_TEXT}
      </span>
    ) : recommend.failed ? (
      RECOMMEND_FAILED_TEXT
    ) : undefined

    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              required: isDetailPage ? false : field.required,
              message: '请选择类目',
            },
          ]}
          extra={
            fieldError || showRate === '1' || showRecommendButton ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {fieldError && <div>{fieldError}</div>}
                {/* 智能推荐按钮紧贴类目框下方，折扣显示在按钮下面（PRD 4.5.1） */}
                {showRecommendButton && (
                  <div className={RecommendStyle.recommendButton}>
                    <Button
                      type="primary"
                      size="small"
                      icon={<BulbOutlined />}
                      disabled={readOnly || recommend.loading}
                      onClick={recommend.recommend}
                    >
                      智能推荐
                    </Button>
                  </div>
                )}
                {showRate === '1' && (
                  <div style={{ marginTop: 4, minHeight: 22 }}>
                    <ExclamationCircleOutlined style={{ marginRight: 4 }} />
                    折扣：{`${displayRate || '--'}%`}
                  </div>
                )}
              </div>
            ) : null
          }
        >
          <Select
            placeholder={recommendPlaceholder || field.description}
            allowClear
            showSearch
            filterOption={false}
            open={recommend.enabled ? recommend.open : undefined}
            optionLabelProp="label"
            // 推荐行有四列，浮层不能跟着窄列宽；人工搜索时仍与输入框等宽
            dropdownMatchSelectWidth={
              recommend.showingRecommendations ? 900 : true
            }
            onDropdownVisibleChange={(visible) => {
              if (!recommend.enabled) return
              // 本次推荐没有结果时，用户再点开下拉框应回到人工搜索结果，
              // 而不是停在"推荐功能失效"的空列表上
              if (visible && !recommend.loading && !recommend.items.length) {
                recommend.hideRecommendations()
              }
              recommend.setOpen(visible)
            }}
            onSearch={(value) => {
              // 人工搜索优先，下拉框让位给搜索结果
              recommend.hideRecommendations()
              debouncedCategorySearch(value)
            }}
            onSelect={(value: any) => {
              recommend.setOpen(false)
              // onChange 只在值变化时触发，点中"已选中的推荐类目"不会走到；用 onSelect 兜住
              const recommended = recommend.items.find(
                (item) => item.categoryCode === value,
              )
              if (recommended && recommend.requestId) {
                selectRecommendedCategory(field.fieldKey!, value)
              }
            }}
            onChange={(value) => {
              recommend.setOpen(false)
              // 推荐项已由 onSelect 处理，这里只管人工选择和清空
              const recommended = recommend.items.find(
                (item) => item.categoryCode === value,
              )
              if (recommended && recommend.requestId) return
              // 改成人工选择的类目或清空，撤销之前登记的采用
              forgetProjectCategoryAdoption(projectCode, field.fieldKey!)
              const item = categoryList.find((item) => item.code === value)
              applyCategorySelection(
                field.fieldKey!,
                value,
                item?.name,
                item?.discountRate,
              )
            }}
            disabled={readOnly}
            notFoundContent={
              recommend.loading ? (
                <div
                  className={`${RecommendStyle.recommendTip} ${RecommendStyle.recommendTipLoading}`}
                >
                  <Spin size="small" />
                  <span>{RECOMMEND_LOADING_TEXT}</span>
                </div>
              ) : recommend.failed ? (
                <div className={RecommendStyle.recommendTip}>
                  {RECOMMEND_FAILED_TEXT}
                </div>
              ) : (
                '无匹配类目'
              )
            }
          >
            {recommend.showingRecommendations
              ? recommend.items.map((item) => (
                  <Select.Option
                    key={item.categoryCode}
                    value={item.categoryCode}
                    label={`${item.categoryCode} ${item.leafName}`}
                  >
                    <div className={RecommendStyle.recommendOption}>
                      <span className={RecommendStyle.recommendPath}>
                        {item.fullPath}
                      </span>
                      <span className={RecommendStyle.recommendLeaf}>
                        {item.leafName}
                      </span>
                      <span className={RecommendStyle.recommendCode}>
                        {item.categoryCode}
                      </span>
                      <span className={RecommendStyle.recommendConfidence}>
                        匹配置信度 {(item.confidence * 100).toFixed(1)}%
                      </span>
                    </div>
                  </Select.Option>
                ))
              : categoryList.map((item) => (
                  <Select.Option
                    key={item.code}
                    value={item.code}
                    label={item.name + '/' + item.code}
                  >
                    {item.name + '/' + item.code}
                  </Select.Option>
                ))}
          </Select>
        </Form.Item>
        <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
          <Input hidden />
        </Form.Item>
        {/* 存储折扣的：默认值为字段 discountRate，下拉选择后更新为选中类目的 discountRate */}
        <Form.Item
          name={`${projectCode}_${field.fieldKey}_rate`}
          initialValue={field.discountRate}
          noStyle
        >
          <Input hidden />
        </Form.Item>
      </Col>
    )
  }
  // 渲染产品词选择器
  const renderProductWordSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => (
    <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
      <Form.Item
        label={field.fieldName}
        name={`${projectCode}_${field.fieldKey}`}
        initialValue={field.fieldValue}
        rules={[
          {
            // 必填规则: 类目下是否存在产品词
            // 配置数据的优先级高于必填规则
            required: isDetailPage
              ? false
              : field.required
                ? !form.getFieldValue(specialField.category) ||
                  (form.getFieldValue(specialField.category) &&
                    productWordList?.length > 0)
                : false,
            message: '请选择产品词',
          },
        ]}
        extra={fieldError}
      >
        <Select
          placeholder={field.description}
          allowClear
          showSearch
          filterOption={(input, option: any) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={(value) => {
            const item = productWordList?.find(
              (item) => item.wordCode === value,
            )
            form.setFieldValue(specialField.attribute, '') // 类目值发生变化清空产品词
            if (item) {
              setHiddenFieldValue(
                form,
                projectCode,
                field.fieldKey!,
                `${item.wordName}/${item.wordCode}`,
              )
            }
            getAttributeRequired(
              form.getFieldValue(specialField.category),
              value,
            )
          }}
          disabled={readOnly}
        >
          {productWordList?.map((item) => (
            <Select.Option key={item.wordCode} value={item.wordCode}>
              {item.wordName + '/' + item.wordCode}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
        <Input hidden />
      </Form.Item>
    </Col>
  )

  // 渲染属性词选择器
  const renderAttributeSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => (
    <Col
      span={8}
      key={`${projectCode}_${field.fieldKey}`}
      style={{ display: 'flex' }}
    >
      <Tooltip title={form.getFieldValue(`${projectCode}_${field.fieldKey}`)}>
        <Form.Item
          style={{ width: '80%' }}
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              // 必填规则: 类目和产品词作为参数查询是否存在属性相关数据
              // 配置数据的优先级高于必填规则
              required: isDetailPage
                ? false
                : field.required
                  ? attributeRequired
                  : false,
              message: '请选择属性词',
            },
            // 航发提交时校验必填属性都已绑定属性值，不依赖是否打开过属性绑定弹框；
            // 其他平台不校验，按类目查属性值可能多达数万条
            ...(!isDetailPage && projectCode === '132'
              ? [
                  {
                    validator: async (_: any, value: any) => {
                      const unbound = await getUnboundRequiredAttributes(
                        value || '',
                      )
                      if (unbound.length) {
                        throw new Error(`请绑定必填属性：${unbound.join('、')}`)
                      }
                    },
                  },
                ]
              : []),
          ]}
          extra={fieldError}
        >
          <Input disabled placeholder={field.description} />
        </Form.Item>
      </Tooltip>
      <Button
        type="link"
        onClick={() => {
          handleAttributeBind(
            form.getFieldValue(`${projectCode}_${field.fieldKey}`) || '',
          )
        }}
        disabled={readOnly}
      >
        属性绑定
      </Button>
    </Col>
  )

  // 渲染下拉选择器
  const renderSelect = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    const isDisabled = disabledStates[field.fieldKey!] || false

    // 被关联字段可编辑时必须必填
    const isRequired =
      field.fieldKey &&
      isDisabled === false && // 可编辑状态
      disabledStates.hasOwnProperty(field.fieldKey) // 是否为被关联字段

    const isShowTooltip = field.description && field.description?.length > 20
    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={
            isShowTooltip ? (
              <Tooltip
                title={field.description}
                getPopupContainer={() => document.body}
              >
                {field.fieldName}
              </Tooltip>
            ) : (
              field.fieldName
            )
          }
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={
            field.fieldEnumValueList?.length
              ? matchEnumOption(field, field.fieldValue)?.value
              : field.fieldValue
          }
          rules={[
            {
              required: isDetailPage
                ? false
                : isDisabled
                  ? false
                  : isRequired || field.required,
              message: `请输入${field.fieldName}`,
            },
          ]}
          extra={fieldError}
        >
          <Select
            placeholder={field.description}
            getPopupContainer={() => document.body}
            disabled={isDisabled || readOnly}
            allowClear
            showSearch
            optionFilterProp="children"
            onChange={(value: string) => {
              const item = field.fieldEnumValueList?.find(
                (item) => item.value === value,
              )
              form.setFieldValue(
                `${projectCode}_${field.fieldKey}_name`,
                item?.label,
              )
            }}
          >
            {field.fieldEnumValueList?.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
          <Input hidden />
        </Form.Item>
      </Col>
    )
  }

  const debouncedSearch = useRef(
    debounce((value: string) => {
      getThirdProductCodeList(value)
    }, 500),
  ).current

  // 渲染标准库物料编码选择器（管网主数据编码、南水北调标品编码等）
  const renderThirdProductCodeSelector = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => (
    <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
      <Form.Item
        label={field.fieldName}
        name={`${projectCode}_${field.fieldKey}`}
        initialValue={field.fieldValue}
        rules={[
          {
            required: isDetailPage ? false : field.required,
            message: field.customErrorMsg ?? `请选择${field.fieldName}`,
          },
        ]}
        extra={fieldError}
      >
        <Select
          placeholder={field.description}
          allowClear
          showSearch
          filterOption={false} // ⚠️ 关键：关闭本地过滤，由后端处理
          // filterOption={(input, option: any) =>
          //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          // }
          onSearch={(value) => {
            setThirdProductSearchName(value)
            debouncedSearch(value)
          }}
          onChange={(value) => {
            const item: any = thirdProductCodeList.find(
              (item) => item.materialCode === value,
            )
            form.setFieldValue(`${projectCode}_${field.fieldKey}`, value)
            form.setFieldValue(
              `${projectCode}_${field.fieldKey}_name`,
              item?.materialName + '/' + item?.materialCode,
            )
          }}
          disabled={readOnly}
          notFoundContent={
            thirdProductSearchName ? '无匹配数据' : '请输入关键词搜索'
          }
        >
          {thirdProductCodeList.map((item) => (
            <Select.Option key={item.materialCode} value={item.materialCode}>
              {item.materialName + '/' + item.materialCode}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name={`${projectCode}_${field.fieldKey}_name`} noStyle>
        <Input hidden />
      </Form.Item>
    </Col>
  )

  // 国铁商城 链接销量渲染（输入框与查询按钮一体，样式参考图示）
  const renderLinkSale = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={field.fieldName}
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              required: isDetailPage ? false : field.required,
              message: '请选择管网主数据编码',
            },
          ]}
          extra={fieldError}
        >
          <Input
            placeholder={field.description}
            addonAfter={
              <Button
                type="link"
                style={{ padding: 0, height: 'auto' }}
                onClick={() => {
                  console.log('查询')
                }}
              >
                查询
              </Button>
            }
          />
        </Form.Item>
      </Col>
    )
  }

  // 渲染普通输入框
  const renderInput = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 使用抽取出来的关联字段逻辑
    const isDisabled = disabledStates[field.fieldKey!] || false
    const isRequired =
      field.fieldKey &&
      isDisabled === false &&
      disabledStates.hasOwnProperty(field.fieldKey)
    const fieldName = `${projectCode}_${field.fieldKey}`

    // NUMBER_STRING：后端期望“数字字符串”（保留前导 0），不能用 InputNumber。
    // 这里统一把输入过滤为纯数字，并在配置了 fieldLength 时裁剪到固定长度，避免表单中出现非法字符或超长值。
    const sanitizeNumberString = (raw: string) => {
      const digitsOnly = (raw ?? '').replace(/\D/g, '')
      if (!field.fieldLength || field.fieldLength <= 0) return digitsOnly
      return digitsOnly.slice(0, field.fieldLength)
    }

    // 不给 InputNumber 设 max：失焦时越界值会被静默改成边界值，用户看不到报错
    const numberRange = NUMBER_RANGE_CONTROL_TYPES.includes(field.controlType!)
      ? parseNumberRange(field.numberRange)
      : undefined

    const isShowTooltip = field.description && field.description?.length > 20
    return (
      <Col span={8} key={`${projectCode}_${field.fieldKey}`}>
        <Form.Item
          label={
            isShowTooltip ? (
              <Tooltip
                title={field.description}
                getPopupContainer={() => document.body}
              >
                {field.fieldName}
              </Tooltip>
            ) : (
              field.fieldName
            )
          }
          name={`${projectCode}_${field.fieldKey}`}
          initialValue={field.fieldValue}
          rules={[
            {
              required: isDetailPage
                ? false
                : isDisabled
                  ? false
                  : isRequired || field.required,
              message: field.customErrorMsg ?? `请输入${field.fieldName}`,
            },
            ...(field.controlType === CONTROL_TYPE.NUMBER_STRING
              ? [
                  {
                    validator: async (_: any, value: any) => {
                      if (value === undefined || value === null || value === '')
                        return
                      const text = String(value)
                      if (!/^\d+$/.test(text)) {
                        throw new Error('只能输入数字')
                      }
                      if (
                        field.fieldLength &&
                        field.fieldLength > 0 &&
                        text.length !== field.fieldLength
                      ) {
                        throw new Error(
                          field.customErrorMsg ??
                            `只能输入${field.fieldLength}位数字`,
                        )
                      }
                    },
                  },
                ]
              : []),
            ...(numberRange
              ? [
                  {
                    validator: async (_: any, value: any) => {
                      const error = checkNumberRange(
                        value,
                        numberRange,
                        field.fieldName,
                      )
                      if (error) throw new Error(error)
                    },
                  },
                ]
              : []),
          ]}
        >
          {(() => {
            switch (field.controlType) {
              case CONTROL_TYPE.NUMBER:
                return (
                  <InputNumber
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    precision={2}
                    min={0}
                    className={
                      isDisabled || readOnly
                        ? Style.disabledInputNumber
                        : undefined
                    }
                    style={{ width: '100%' }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              case CONTROL_TYPE.INTEGER:
                return (
                  <InputNumber
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    precision={0}
                    className={
                      isDisabled || readOnly
                        ? Style.disabledInputNumber
                        : undefined
                    }
                    style={{ width: '100%' }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              case CONTROL_TYPE.POSITIVE_INTERGE:
                return (
                  <InputNumber
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    precision={0}
                    min={1}
                    className={
                      isDisabled || readOnly
                        ? Style.disabledInputNumber
                        : undefined
                    }
                    style={{ width: '100%' }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              case CONTROL_TYPE.NUMBER_STRING:
                return (
                  <Input
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    // 移动端优先弹数字键盘；PC 端仍以 onChange 过滤为准
                    inputMode="numeric"
                    pattern="[0-9]*"
                    // 配合 onChange 裁剪：限制输入位数（用于数字字符串，例如编码类字段）
                    maxLength={field.fieldLength || undefined}
                    onChange={(e) => {
                      // 强制过滤非数字并在配置 fieldLength 时裁剪到固定长度，再回写表单值
                      const next = sanitizeNumberString(e.target.value)
                      form.setFieldValue(fieldName, next)
                    }}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
              default:
                return (
                  <Input
                    placeholder={field.description}
                    disabled={isDisabled || readOnly}
                    maxLength={field.fieldLength || undefined}
                    onBlur={() => triggerRelateFieldCalc(field.fieldKey!)}
                  />
                )
            }
          })()}
        </Form.Item>
      </Col>
    )
  }

  // 渲染单个字段
  const renderField = (
    field: ExtendedInfo,
    projectCode: string,
    form: FormInstance,
    fieldError?: any,
  ) => {
    // 字段验证
    if (!field.fieldKey || !field.fieldName) {
      console.warn('字段配置不完整:', field)
      return null
    }

    // 品牌选择器
    if (field.fieldMeaning === FIELD_MEANING.BRAND) {
      return renderBrandSelector(field, projectCode, form, fieldError)
    }

    // 类目选择器
    if (field.fieldMeaning === FIELD_MEANING.CATEGORY) {
      return renderCategorySelector(field, projectCode, form, fieldError)
    }

    // 产品词选择器
    if (field.fieldMeaning === FIELD_MEANING.PRODUCT_WORD) {
      return renderProductWordSelector(field, projectCode, form, fieldError)
    }

    // 属性词选择器
    if (field.fieldMeaning === FIELD_MEANING.ATTRIBUTE_CODE) {
      return renderAttributeSelector(field, projectCode, form, fieldError)
    }

    if (field.fieldMeaning === FIELD_MEANING.THIRD_PRODUCT_CODE) {
      return renderThirdProductCodeSelector(
        field,
        projectCode,
        form,
        fieldError,
      )
    }

    if (
      field.fieldMeaning !== FIELD_MEANING.BRAND &&
      field.fieldMeaning !== FIELD_MEANING.CATEGORY &&
      field.fieldMeaning !== FIELD_MEANING.PRODUCT_WORD &&
      field.fieldMeaning !== FIELD_MEANING.THIRD_PRODUCT_CODE &&
      field.controlType === CONTROL_TYPE.SELECT
    ) {
      return renderSelect(field, projectCode, form, fieldError)
    }

    // 电能e购 31 平台时 且  fieldKey 为 convertScale 时 requireMessage 为 换算比例字段必填，请检查后重试

    // if()

    // 默认输入框
    return renderInput(field, projectCode, form, fieldError)
  }

  // 启用 AI 推荐的平台，类目字段连同下方的推荐按钮一起排到最后（PRD 4.5.1）
  const orderedFieldList = useMemo(() => {
    if (!recommend.enabled) return extendedInfoList
    const categoryFields = extendedInfoList.filter(
      (field) => field.fieldMeaning === FIELD_MEANING.CATEGORY,
    )
    if (!categoryFields.length) return extendedInfoList
    return [
      ...extendedInfoList.filter(
        (field) => field.fieldMeaning !== FIELD_MEANING.CATEGORY,
      ),
      ...categoryFields,
    ]
  }, [extendedInfoList, recommend.enabled])

  const handleDownload = async (
    downloadType: 'category' | 'brand' | 'standardLibrary',
  ) => {
    const downloadMap = {
      category: POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY,
      brand: POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND,
      standardLibrary: POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY,
    }
    const res = await downloadMap[downloadType]({ platformCode: projectCode })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    }
  }

  return (
    <Spin spinning={loading}>
      {extendedInfoList.length > 0 ? (
        <div className={Style.sectionContainer}>
          <Row gutter={16}>
            {orderedFieldList.map((field) => {
              const fieldError = field.fieldKey
                ? preCheckErrors?.extendedAttributeError?.[
                    field.fieldKey as string
                  ]
                : undefined
              const fieldErrorElement = fieldError ? (
                <div
                  style={{
                    color: '#FF7D00',
                    fontSize: '14px',
                    lineHeight: '24px',
                  }}
                >
                  {fieldError}
                </div>
              ) : null
              return renderField(field, projectCode, form, fieldErrorElement)
            })}

            {validationInfo}
          </Row>
        </div>
      ) : null}
      <Form
        form={normalForm}
        {...formItemLayout}
        labelAlign="right"
        style={{ margin: '0 0 16px 0' }}
        colon={false}
      >
        {projectCode === '46' && isShowSaleInfo ? (
          <div className={Style.sectionContainer}>
            <div className={Style.sectionTitle}>销售审核</div>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="saleJobNumber"
                  label="销售员"
                  rules={[
                    {
                      required: !isDetailPage,
                      message: '请选择销售员',
                    },
                  ]}
                >
                  <Select
                    disabled={readOnly}
                    showSearch
                    optionFilterProp="name"
                    placeholder="请选择销售人员"
                    options={wuhanSalePersonList}
                    onChange={(value: string) => {
                      const item = wuhanSalePersonList.find(
                        (item) => item.jobNumber === value,
                      )
                      normalForm.setFieldsValue({
                        saleName: item?.name,
                        saleJobNumber: item?.jobNumber,
                      })
                    }}
                    fieldNames={{ label: 'name', value: 'jobNumber' }}
                  />
                </Form.Item>
                <Form.Item name="saleName" label="销售员名称" noStyle>
                  <Input hidden />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="saleRemark"
                  label="提报备注"
                  rules={[
                    {
                      required: !isDetailPage,
                      message: '请输入提报备注',
                    },
                  ]}
                >
                  <Input placeholder="请输入提报备注" disabled={readOnly} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        ) : null}
      </Form>
      {/* 商品资质图片 */}
      <div className={Style.sectionContainer}>
        <div className={Style.sectionTitle}>
          <Tooltip
            title="最多支持十条资质信息"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined />
          </Tooltip>
          商品资质图片
          <Button
            type="primary"
            size="small"
            className={Style.uploadButton}
            onClick={onClickBatch}
            disabled={readOnly}
          >
            上传资质图片
          </Button>
        </div>
        <Table
          rowKey="url"
          dataSource={qualityDataList}
          columns={qualityColumns}
          scroll={{ y: 300 }}
          pagination={false}
        />
      </div>

      <div className={Style.sectionContainer}>
        <div className={Style.sectionTitle}>客户基础数据</div>
        <Space style={{ marginLeft: '22px' }}>
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('category')}
          >
            客户分类下载
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('brand')}
          >
            客户品牌下载
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => handleDownload('standardLibrary')}
          >
            客户标准库下载
          </Button>
        </Space>
      </div>

      {/* 图片预览弹窗 */}
      <PreviewUser
        images={previewimg}
        onClose={() =>
          setPreviewimg({
            data: [],
          })
        }
      />

      {/* 批量上传 */}
      <CustomModal
        title="批量上传"
        open={batchVisible}
        width={470}
        modalCancel={onCancelBatch}
        footer={
          <div className={Style.modalFooter}>
            <Button
              disabled={uploadLoading}
              type="primary"
              size="middle"
              onClick={onCancelBatch}
            >
              取消
            </Button>
            <Button
              disabled={uploadLoading}
              type="primary"
              size="middle"
              onClick={onSaveBatch}
            >
              保存
            </Button>
          </div>
        }
      >
        <Spin spinning={uploadLoading}>
          <Form form={qualityList}>
            <Form.Item
              name="sourceType"
              label="图片资质类型"
              rules={[{ required: true, message: '请选择图片资质类型' }]}
              style={{ marginBottom: 0 }}
            >
              <Select
                placeholder="请选择图片资质类型"
                style={{ width: '300px' }}
                getPopupContainer={() => document.body}
                options={qualityTypeList}
              />
            </Form.Item>
          </Form>
          <UpdateImg
            // platformCode={platformCode}
            dataSource={uploadFileData}
            onChange={changeFileData}
            setUploadLoading={setUploadLoading}
          />
        </Spin>
      </CustomModal>
      <CustomModal
        title="属性绑定"
        open={attributeBindVisible}
        width={1000}
        modalCancel={onCancelAttributeBind}
        footer={
          <div
            style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}
          >
            <Button onClick={onCancelAttributeBind}>取消</Button>
            <Button
              type="primary"
              onClick={handleSaveAllAttributes}
              loading={attributeBindLoading}
            >
              保存
            </Button>
          </div>
        }
      >
        <Spin spinning={attributeBindLoading}>
          <Form form={attributeBindForm}>
            <Table
              dataSource={attributeBindData}
              columns={attributeBindColumns}
              scroll={{ y: 300 }}
              pagination={false}
              rowKey="specAttributeId"
              className={Style.attributeTable}
            />
          </Form>
        </Spin>
      </CustomModal>
    </Spin>
  )
}

export default GoodsSubmissionInfo
